/**
 * ============================================================
 *  YMM Native Filter Bridge  v21
 *  huntercompany.com
 * ============================================================
 *
 *  NOVIDADES v21:
 *  - Filtros ativos ficam na URL (?f_carry-style=...&f_draw-hand=...)
 *    junto com ?rq=. O link pode ser compartilhado, recarregado ou
 *    acessado pelo botão Voltar com os mesmos filtros aplicados.
 *
 *  NOVIDADES v20:
 *  - Imagens em full resolution (_240x240 → _800x800)
 *  - Label de firearm com Barrel + Caliber abaixo do searchbar
 *    (lookup normalizado para tolerar perda de pontos decimais
 *     e caracteres especiais na conversão de hífens para espaços)
 *
 *  THEME.LIQUID — mantenha o bloco de spinner:
 *
 *    {%- if request.page_type == 'page' and page.handle == 'product-result' -%}
 *      <style id="ymm-hide-immediate">
 *        .page-ymm-custom .ymm_content,
 *        #product_container { visibility: hidden; opacity: 0; }
 *      </style>
 *      <div id="ymm-spinner-wrap"><div id="ymm-spinner"></div></div>
 *      <style>
 *        #ymm-spinner-wrap {
 *          position: fixed; inset: 0; z-index: 9999;
 *          display: flex; align-items: center; justify-content: center;
 *          background: rgba(255,255,255,0.75); backdrop-filter: blur(2px);
 *        }
 *        #ymm-spinner {
 *          width: 48px; height: 48px;
 *          border: 4px solid #e1e3e4; border-top-color: #111;
 *          border-radius: 50%; animation: ymm-spin 0.75s linear infinite;
 *        }
 *        @keyframes ymm-spin { to { transform: rotate(360deg); } }
 *      </style>
 *    {%- endif -%}
 *    <script src="{{ 'ymm-shopify-filter-bridge.js' | asset_url }}" defer></script>
 * ============================================================
 */

/* ============================================================
   SINGLE-PRODUCT REDIRECT INTERCEPTOR  (v22)
   Origem: assets/ymm-redirect-interceptor.js do tema legado.

   O app YMM carrega do CDN de extensões da Shopify, então não dá
   pra editar o código dele. Quando a busca acha um só produto, o
   cwsApp.ymmURLRedirect manda o cliente direto pra /products/...
   Este bloco troca essa função por uma versão que, nesse caso,
   manda pra página de resultados com o mesmo ?rq=.
   Busca com vários resultados e links externos seguem iguais.

   Roda em todas as páginas (o widget de busca aparece fora da
   página de resultados), por isso fica FORA do bloco principal,
   que só roda em /pages/product-result.
============================================================ */
(function () {
  if (window.__hunterYmmInterceptor) return;   // evita rodar duas vezes
  window.__hunterYmmInterceptor = true;

  var RESULT_PAGE = '/pages/product-result';
  function dlog() {
    if (window.HUNTER_YMM_DEBUG) console.log.apply(console, ['[YMM Interceptor]'].concat([].slice.call(arguments)));
  }

  /* Versão corrigida do ymmURLRedirect */
  function makePatched(orig) {
    return async function (ymmTildeTag) {
      try {
        var dataUrl = window.ymmDataUrl || '';
        if (!dataUrl) {
          console.warn('[YMM Interceptor] ymmDataUrl not found, falling back.');
          return orig.call(this, ymmTildeTag);
        }

        var params = new URLSearchParams({
          domain:       window.ymmShopDomain  || '',
          front_domain: window.ymmFrontDomain || '',
          action:       'get_single_product',
          dbl_score:    'yes',
          tags:         ymmTildeTag,
          route_url:    window.ymmRouteUrl    || ''
        });

        var res = await fetch(dataUrl + '?' + params.toString(), { method: 'GET' });
        if (!res.ok) throw new Error('HTTP ' + res.status);

        var json = await res.json();
        var dest = json.retArr && json.retArr.redirect_url;

        if (!dest) return orig.call(this, ymmTildeTag);

        if (dest.indexOf('/products/') !== -1) {
          // Um só produto: fica na página de resultados
          var rq      = ymmTildeTag.toString().replace(/~/g, '__');
          var stayUrl = (window.ymmSearchURL || RESULT_PAGE) + '?rq=' + encodeURIComponent(rq);
          dlog('Single-product blocked ->', stayUrl);
          window.location.href = stayUrl;
        } else if (json.retArr.new_window === '1') {
          var a = document.createElement('a');
          a.href = dest; a.target = '_blank';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
        } else {
          window.location.href = dest;
        }
      } catch (e) {
        console.warn('[YMM Interceptor] Error, falling back:', e.message);
        return orig.call(this, ymmTildeTag);
      }
    };
  }

  /* Aplica a troca quando cwsApp.ymmURLRedirect existe */
  function applyPatch(obj) {
    if (!obj || !obj.ymmURLRedirect || obj._hunterPatched) return false;
    obj.ymmURLRedirect = makePatched(obj.ymmURLRedirect);
    obj._hunterPatched = true;
    dlog('Patch applied');
    return true;
  }

  /* Armadilha: dispara no instante em que cwsApp.ymmURLRedirect é definido */
  function trapYmmURLRedirect(cwsApp) {
    if (cwsApp._hunterTrapped) return;
    cwsApp._hunterTrapped = true;

    if (cwsApp.ymmURLRedirect) { applyPatch(cwsApp); return; }

    var _fn;
    try {
      Object.defineProperty(cwsApp, 'ymmURLRedirect', {
        configurable: true,
        enumerable:   true,
        get: function () { return _fn; },
        set: function (fn) {
          Object.defineProperty(cwsApp, 'ymmURLRedirect', {
            configurable: true, enumerable: true, writable: true, value: fn
          });
          applyPatch(cwsApp);
        }
      });
      dlog('Property trap set on cwsApp.ymmURLRedirect');
    } catch (e) {
      var t = setInterval(function () { if (applyPatch(cwsApp)) clearInterval(t); }, 50);
      setTimeout(function () { clearInterval(t); }, 15000);
    }
  }

  /* Armadilha: dispara no instante em que window.cwsApp é definido */
  function trapCwsApp() {
    if (window.cwsApp) { trapYmmURLRedirect(window.cwsApp); return; }

    try {
      Object.defineProperty(window, 'cwsApp', {
        configurable: true,
        enumerable:   true,
        get: function () { return undefined; },
        set: function (obj) {
          Object.defineProperty(window, 'cwsApp', {
            configurable: true, enumerable: true, writable: true, value: obj
          });
          if (obj) trapYmmURLRedirect(obj);
        }
      });
      dlog('Property trap set on window.cwsApp');
    } catch (e) {
      var t = setInterval(function () {
        if (window.cwsApp) { clearInterval(t); trapYmmURLRedirect(window.cwsApp); }
      }, 50);
      setTimeout(function () { clearInterval(t); }, 15000);
    }
  }

  trapCwsApp();
})();

(function () {

  /* ─────────────────────────────────────────────
     CATÁLOGO ESTÁTICO DE FILTROS
  ───────────────────────────────────────────── */
  const FILTER_CATALOG = [
    { cat: 'Optic Compatible',        vals: ['Yes', 'No'] },
    { cat: 'Light Compatible',   vals: ['Yes', 'No'] },
    { cat: 'Use', vals: [
      'Everyday Carry', 'Concealed Carry', 'Classic Western', 'Hunting & Outdoors',
    ]},
    { cat: 'Draw Hand', vals: ['Right Hand', 'Left Hand', 'Ambidextrous'] },
    { cat: 'Carry Style', vals: [
      'Outside Waistband (OWB)', 'Inside Waistband (IWB)', 'Cross Draw',
      'Shoulder Carry', 'Bandolier Carry', 'Pocket Carry',
    ]},
    { cat: 'Carry Position', vals: [
      'Appendix (12–2 O\'Clock)', 'Strong-Side (2–3 O\'Clock)',
      'Kidney (4–5 O\'Clock)', 'Small of Back (5–6 O\'Clock)',
      'Cross Draw (10–11 O\'Clock)', 'Other (Shoulder, Bandolier, Pocket)',
    ]},
    { cat: 'Retention Method', vals: [
      'Open Top', 'Thumb Break', 'Adjustable Retention', 'Safety Strap',
      'Hammer Thong', 'Flap Cover',
    ]},
    { cat: 'Ride Height', vals: ['High Ride', 'Mid Ride', 'Low Ride'] },
    { cat: 'Cant Angle',  vals: ['Forward Cant', 'Neutral Cant', 'Reverse Cant', 'Adjustable Cant'] },
    { cat: 'Bottom Style',  vals: ['Open Bottom', 'Closed Bottom'] },
    { cat: 'Belt Compatibility', vals: [
      'Up to 1.50" Width', 'Up to 2.00" Width', 'Up to 2.50" Width',
      'Up to 2.75" Width', 'Up to 3.00" Width', 'Buscadero Belts',
    ]},
    { cat: 'Available Colors', vals: [
      'Exotic Styles', 'Chestnut Tan (Full Grain)', 'Antique Brown (Full Grain)',
      'Black (Full Grain)', 'Black (Suede)', 'Brown (Suede)', 'Oro Russet (Suede)',
    ]},
  ];

  /* ─────────────────────────────────────────────
     FIREARM SPECS LOOKUP
     Key = "Make_Model" exactly as in the YMM plugin list.
     Matching is normalized (strips dots, slashes, parens, spaces)
     so URL-decoded "4 25 in w rail" matches "4.25 in w/ Rail".
  ───────────────────────────────────────────── */
  const FIREARM_SPECS = {
    '1911 Models_Commander Size (4.25 in)': { barrel: '4.25"', caliber: 'Multiple Calibers' },
    '1911 Models_Commander Size (4.25 in) w/ Rail': { barrel: '4.25"', caliber: 'Multiple Calibers' },
    '1911 Models_Full Size (5 in)': { barrel: '5"', caliber: 'Multiple Calibers' },
    '1911 Models_Full Size (5 in) w/ Rail': { barrel: '5"', caliber: 'Multiple Calibers' },
    'American Derringer_Lady Derringer': { barrel: '3"', caliber: 'Multiple Calibers' },
    'American Derringer_Model 1': { barrel: '3"', caliber: 'Multiple Calibers' },
    'American Derringer_Model 10': { barrel: '3"', caliber: 'Multiple Calibers' },
    'American Derringer_Model 11': { barrel: '3"', caliber: 'Multiple Calibers' },
    'American Derringer_Model 7': { barrel: '3"', caliber: 'Multiple Calibers' },
    'AMT_Government': { barrel: '5"', caliber: '.45 ACP' },
    'Armi Jager_Dakota-4.75 / .357 Mag': { barrel: '4.75"', caliber: '.357 Mag' },
    'Armi Jager_Dakota-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'Armi Jager_Super Dakota': { barrel: '7.5"', caliber: '.44 Mag' },
    'Astra_4000 Falcon-3.875 / .22 LR': { barrel: '3.875"', caliber: '.22 LR' },
    'Astra_4000 Falcon-3.875 / .32 ACP': { barrel: '3.875"', caliber: '.32 ACP' },
    'Astra_4000 Falcon-3.875 / .380 ACP': { barrel: '3.875"', caliber: '.380 ACP' },
    'Astra_A-80-3.75 / .45 ACP': { barrel: '3.75"', caliber: '.45 ACP' },
    'Astra_A-80-3.75 / 9 mm': { barrel: '3.75"', caliber: '9mm' },
    'Astra_Camper': { barrel: '4"', caliber: '.22 Short' },
    'Astra_Constable-3.5 / .22 LR': { barrel: '3.5"', caliber: '.22 LR' },
    'Astra_Constable-3.5 / .32 ACP': { barrel: '3.5"', caliber: '.32 ACP' },
    'Astra_Constable-3.5 / .380 ACP': { barrel: '3.5"', caliber: '.380 ACP' },
    'Astra_Cub-2.25 / .22 Short': { barrel: '2.25"', caliber: '.22 Short' },
    'Astra_Cub-2.25 / .25 ACP': { barrel: '2.25"', caliber: '.25 ACP' },
    'Auto_Ordnance-1911A1-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Auto_Ordnance-1911A1-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Beretta_21A Bobcat-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'Beretta_21A Bobcat-2.5 / .25 ACP': { barrel: '2.5"', caliber: '.25 ACP' },
    'Beretta_3032 Tomcat': { barrel: '2.4"', caliber: '.32 ACP' },
    'Beretta_418 Bantam/Panther': { barrel: '2.5"', caliber: '.25 ACP' },
    'Beretta_70 Puma': { barrel: '3.5"', caliber: '.32 ACP' },
    'Beretta_8000 Cougar': { barrel: '3.6"', caliber: '9mm' },
    'Beretta_8000D Cougar': { barrel: '3.6"', caliber: '9mm' },
    'Beretta_8000F Cougar': { barrel: '3.6"', caliber: '9mm' },
    'Beretta_8040F Cougar Mini': { barrel: '3.6"', caliber: '.40 S&W' },
    'Beretta_92': { barrel: '4.92"', caliber: '9mm' },
    'Beretta_92A1': { barrel: '4.9"', caliber: '9mm' },
    'Beretta_92F': { barrel: '5"', caliber: '9mm' },
    'Beretta_92FS': { barrel: '4.9"', caliber: '9mm' },
    'Beretta_92SB': { barrel: '4.92"', caliber: '9mm' },
    'Beretta_950 Jetfire/Minx-2.36 / .22 Short': { barrel: '2.36"', caliber: '.22 Short' },
    'Beretta_950 Jetfire/Minx-2.36 / .25 ACP': { barrel: '2.36"', caliber: '.25 ACP' },
    'Beretta_96': { barrel: '4.9"', caliber: '.40 S&W' },
    'Beretta_96A1': { barrel: '4.9"', caliber: '.40 S&W' },
    'Beretta_APX-4.25 / .40 S&W': { barrel: '4.25"', caliber: '.40 S&W' },
    'Beretta_APX-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Beretta_APX A1': { barrel: '4.25"', caliber: '9mm' },
    'Beretta_APX A1 Carry': { barrel: '3"', caliber: '9mm' },
    'Beretta_APX A1 Compact': { barrel: '3.7"', caliber: '9mm' },
    'Beretta_APX Carry': { barrel: '3"', caliber: '9mm' },
    'Beretta_APX Centurion-3.7 / .40 S&W': { barrel: '3.7"', caliber: '.40 S&W' },
    'Beretta_APX Centurion-3.7 / 9 mm': { barrel: '3.7"', caliber: '9mm' },
    'Beretta_APX Compact-3.7 / .40 S&W': { barrel: '3.7"', caliber: '.40 S&W' },
    'Beretta_APX Compact-3.7 / 9 mm': { barrel: '3.7"', caliber: '9mm' },
    'Beretta_M9': { barrel: '4.92"', caliber: '9mm' },
    'Beretta_M9A1': { barrel: '4.92"', caliber: '9mm' },
    'Beretta_M9A3': { barrel: '4.92"', caliber: '9mm' },
    'Beretta_PX4 Storm-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Beretta_PX4 Storm-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Beretta_PX4 Storm-4.13 / .45 ACP': { barrel: '4.13"', caliber: '.45 ACP' },
    'Beretta_PX4 Storm Compact-3.2 / .40 S&W': { barrel: '3.2"', caliber: '.40 S&W' },
    'Beretta_PX4 Storm Compact-3.2 / 9 mm': { barrel: '3.2"', caliber: '9mm' },
    'Beretta_PX4 Storm Subcompact-3 / .40 S&W': { barrel: '3"', caliber: '.40 S&W' },
    'Beretta_PX4 Storm Subcompact-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Bernardelli_Model 60-3.5 / .22 LR': { barrel: '3.5"', caliber: '.22 LR' },
    'Bernardelli_Model 60-3.5 / .32 ACP': { barrel: '3.5"', caliber: '.32 ACP' },
    'Bernardelli_Model 60-3.5 / .380 ACP': { barrel: '3.5"', caliber: '.380 ACP' },
    'Bernardelli_Model 80': { barrel: '3.5"', caliber: '.380 ACP' },
    'Bersa_Thunder 380': { barrel: '3.5"', caliber: '.380 ACP' },
    'Bersa_Thunder 9 Pro XT': { barrel: '4.96"', caliber: '9mm' },
    'Bersa_TPR9C': { barrel: '3.25"', caliber: '9mm' },
    'Black Powder Guns_Ruger Old Army': { barrel: '7.5"', caliber: '.44 Caliber' },
    'Boberg_XR9-L': { barrel: '4.2"', caliber: '9mm' },
    'Bond Arms_Backup': { barrel: '2.5"', caliber: '.45 ACP' },
    'Bond Arms_Century 2000': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Cowboy Defender': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Cub': { barrel: '2.5"', caliber: '.357 Mag' },
    'Bond Arms_Girl Mini': { barrel: '2.5"', caliber: '.357 Mag' },
    'Bond Arms_Grizzly': { barrel: '3"', caliber: '.45 LC / .410 Bore' },
    'Bond Arms_Mama Bear': { barrel: '2.5"', caliber: '.357 Mag' },
    'Bond Arms_Mini 45': { barrel: '2.5"', caliber: '.45 Colt' },
    'Bond Arms_Papa Bear': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Patriot': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Roughneck': { barrel: '2.5"', caliber: 'Multiple Calibers' },
    'Bond Arms_Rowdy': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Stinger': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Stinger RS': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_Texas Defender': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Bond Arms_USA Defender': { barrel: '3"', caliber: 'Multiple Calibers' },
    'Browning_1911-22 A1': { barrel: '4.25"', caliber: '.22 LR' },
    'Browning_1911-380': { barrel: '4.25"', caliber: '.380 ACP' },
    'Browning_BDA 380': { barrel: '3.8"', caliber: '.380 ACP' },
    'Browning_Buckmark': { barrel: '5.5"', caliber: '.22 LR' },
    'Browning_Challenger-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'Browning_Challenger-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Browning_Challenger-6.75 / .22 LR': { barrel: '6.75"', caliber: '.22 LR' },
    'Browning_Hi-Power Mark III': { barrel: '4.75"', caliber: '9mm' },
    'Browning_Nomad-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'Browning_Nomad-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Browning_Nomad-6.75 / .22 LR': { barrel: '6.75"', caliber: '.22 LR' },
    'Browning_Standard-3.5 / .380 ACP': { barrel: '3.5"', caliber: '.380 ACP' },
    'Browning_Standard-4.625 / 9 mm': { barrel: '4.625"', caliber: '9mm' },
    'Canik_Mete MC9': { barrel: '3.18"', caliber: '9mm' },
    'Canik_TP9 Elite SC': { barrel: '3.6"', caliber: '9mm' },
    'Canik_TP9SA': { barrel: '4.46"', caliber: '9mm' },
    'Canik_TP9SA Mod.2': { barrel: '4.46"', caliber: '9mm' },
    'Canik_TP9SF': { barrel: '4.46"', caliber: '9mm' },
    'Charter Arms_Bulldog': { barrel: '3"', caliber: '.44 Special' },
    'Charter Arms_Off Duty': { barrel: '2"', caliber: '.38 Special' },
    'Charter Arms_Pathfinder-2 / .22 LR': { barrel: '2"', caliber: '.22 LR' },
    'Charter Arms_Pathfinder-2 / .22 Mag': { barrel: '2"', caliber: '.22 Mag' },
    'Charter Arms_Pathfinder-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Charter Arms_Police Bulldog': { barrel: '4"', caliber: '.38 Special' },
    'Charter Arms_Undercover-2 / .38 Special': { barrel: '2"', caliber: '.38 Special' },
    'Charter Arms_Undercover-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Charter Arms_Undercoverette-2 / .32 Mag': { barrel: '2"', caliber: '.32 Mag' },
    'Charter Arms_Undercoverette-2 / .32 S&W': { barrel: '2"', caliber: '.32 S&W' },
    'Cimarron_Buffalo Bill Frontier-4.75 / .45 Long Colt': { barrel: '4.75"', caliber: '.45 Long Colt' },
    'Cimarron_Buffalo Bill Frontier-5.5 / .45 Long Colt': { barrel: '5.5"', caliber: '.45 Long Colt' },
    'Clerke_Model CF-200': { barrel: '2.25"', caliber: '.22 LR' },
    'Cody_Thunderbird': { barrel: '4"', caliber: '.22 LR' },
    'Colt_357-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Colt_357-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Colt_Agent': { barrel: '2"', caliber: '.38 Special' },
    'Colt_Anaconda-4 / .44 Mag': { barrel: '4"', caliber: '.44 Mag' },
    'Colt_Anaconda-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Colt_Anaconda-6 / .45 Long Colt': { barrel: '6"', caliber: '.45 Long Colt' },
    'Colt_Anaconda-8 / .44 Mag': { barrel: '8"', caliber: '.44 Mag' },
    'Colt_Anaconda-8 / .45 Long Colt': { barrel: '8"', caliber: '.45 Long Colt' },
    'Colt_Buntline Scout': { barrel: '9.5"', caliber: '.22 LR' },
    'Colt_Cobra-2 / .32 S&W Long': { barrel: '2"', caliber: '.32 S&W Long' },
    'Colt_Cobra-2 / .38 Special': { barrel: '2"', caliber: '.38 Special' },
    'Colt_Combat Commander-4.25 / .38 Super': { barrel: '4.25"', caliber: '.38 Super' },
    'Colt_Combat Commander-4.25 / .45 ACP': { barrel: '4.25"', caliber: '.45 ACP' },
    'Colt_Combat Commander-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Colt_Combat Elite': { barrel: '5"', caliber: '.45 ACP' },
    'Colt_Combat Government': { barrel: '5"', caliber: '.45 ACP' },
    'Colt_Commander-4.25 / .38 Super': { barrel: '4.25"', caliber: '.38 Super' },
    'Colt_Commander-4.25 / .45 ACP': { barrel: '4.25"', caliber: '.45 ACP' },
    'Colt_Commander-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Colt_Commando': { barrel: '4"', caliber: '.38 Special' },
    'Colt_Courier': { barrel: '3"', caliber: '.32 S&W Long' },
    'Colt_Defender-3 / .45 ACP': { barrel: '3"', caliber: '.45 ACP' },
    'Colt_Defender-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Colt_Delta Elite': { barrel: '5"', caliber: '10mm' },
    'Colt_Detective Special': { barrel: '2"', caliber: '.38 Special' },
    'Colt_Diamondback-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Colt_Diamondback-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Colt_Frontier Scout': { barrel: '4.75"', caliber: '.22 Calibers' },
    'Colt_Gold Cup': { barrel: '5"', caliber: '.45 ACP' },
    'Colt_Government-3.25 / .380 ACP': { barrel: '3.25"', caliber: '.380 ACP' },
    'Colt_Government-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Colt_Huntsman': { barrel: '6"', caliber: '.22 LR' },
    'Colt_King Cobra-2 / .357 Mag': { barrel: '2"', caliber: '.357 Mag' },
    'Colt_King Cobra-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Colt_King Cobra-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Colt_Lawman Mk III-2 / .357 Mag': { barrel: '2"', caliber: '.357 Mag' },
    'Colt_Lawman Mk III-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Colt_M1911': { barrel: '5"', caliber: '.45 ACP' },
    'Colt_M1917': { barrel: '5.5"', caliber: '.45 ACP' },
    'Colt_Marshal': { barrel: '4"', caliber: '.38 Special' },
    'Colt_Metropolitan': { barrel: '4"', caliber: '.38 Special' },
    'Colt_Mustang': { barrel: '2.75"', caliber: '.380 ACP' },
    'Colt_New Frontier-4.75 / .357 Mag': { barrel: '4.75"', caliber: '.357 Mag' },
    'Colt_New Frontier-4.75 / .45 Long Colt': { barrel: '4.75"', caliber: '.45 Long Colt' },
    'Colt_New Frontier-5.5 / .357 Mag': { barrel: '5.5"', caliber: '.357 Mag' },
    'Colt_New Frontier-5.5 / .45 Long Colt': { barrel: '5.5"', caliber: '.45 Long Colt' },
    'Colt_New Frontier-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'Colt_New Frontier-7.5 / .45 Long Colt': { barrel: '7.5"', caliber: '.45 Long Colt' },
    'Colt_New Service-5 / .45 Colt': { barrel: '5"', caliber: '.45 Colt' },
    'Colt_New Service-6 / .45 Colt': { barrel: '6"', caliber: '.45 Colt' },
    'Colt_New Service-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'Colt_Officers ACP': { barrel: '3.5"', caliber: '.45 ACP' },
    'Colt_Officers Model-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Colt_Officers Model-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Colt_Official Police-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Colt_Official Police-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Colt_Peacemaker-4.75 / .45 Long Colt': { barrel: '4.75"', caliber: '.45 Long Colt' },
    'Colt_Peacemaker-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Colt_Peacemaker-6 / .22 Mag': { barrel: '6"', caliber: '.22 Mag' },
    'Colt_Peacemaker-7.5 / .22 Mag': { barrel: '7.5"', caliber: '.22 Mag' },
    'Colt_Police Positive-4 / .32 Calibers': { barrel: '4"', caliber: '.32 Calibers' },
    'Colt_Police Positive-5 / .32 Calibers': { barrel: '5"', caliber: '.32 Calibers' },
    'Colt_Police Positive-6 / .32 Calibers': { barrel: '6"', caliber: '.32 Calibers' },
    'Colt_Police Positive Special-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Colt_Police Positive Special-5 / .38 Special': { barrel: '5"', caliber: '.38 Special' },
    'Colt_Police Positive Special-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Colt_Python-2.5 / .357 Mag': { barrel: '2.5"', caliber: '.357 Mag' },
    'Colt_Python-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Colt_Python-5 / .357 Mag': { barrel: '5"', caliber: '.357 Mag' },
    'Colt_Python-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Colt_Python-8 / .357 Mag': { barrel: '8"', caliber: '.357 Mag' },
    'Colt_Single Action Army-4.75 / .32-20 WCF': { barrel: '4.75"', caliber: '.32-20 WCF' },
    'Colt_Single Action Army-4.75 / .357 Mag': { barrel: '4.75"', caliber: '.357 Mag' },
    'Colt_Single Action Army-4.75 / .38 Special': { barrel: '4.75"', caliber: '.38 Special' },
    'Colt_Single Action Army-4.75 / .44-40 WCF': { barrel: '4.75"', caliber: '.44-40 WCF' },
    'Colt_Single Action Army-4.75 / .45 Colt': { barrel: '4.75"', caliber: '.45 Colt' },
    'Colt_Single Action Army-5.5 / .32-20 WCF': { barrel: '5.5"', caliber: '.32-20 WCF' },
    'Colt_Single Action Army-5.5 / .357 Mag': { barrel: '5.5"', caliber: '.357 Mag' },
    'Colt_Single Action Army-5.5 / .38 Special': { barrel: '5.5"', caliber: '.38 Special' },
    'Colt_Single Action Army-5.5 / .44-40 WCF': { barrel: '5.5"', caliber: '.44-40 WCF' },
    'Colt_Single Action Army-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'Colt_Single Action Army-7.5 / .32-20 WCF': { barrel: '7.5"', caliber: '.32-20 WCF' },
    'Colt_Single Action Army-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'Colt_Single Action Army-7.5 / .38 Special': { barrel: '7.5"', caliber: '.38 Special' },
    'Colt_Single Action Army-7.5 / .44-40 WCF': { barrel: '7.5"', caliber: '.44-40 WCF' },
    'Colt_Single Action Army-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'Colt_Trooper-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Colt_Trooper-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Colt_Trooper-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Colt_Trooper-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Colt_Woodsman': { barrel: '6"', caliber: '.22 LR' },
    'Colt_Woodsman Target': { barrel: '6"', caliber: '.22 LR' },
    'Crosman_38C-3.5 / .177 BB Pellets': { barrel: '3.5"', caliber: '.177 BB Pellets' },
    'Crosman_38C-3.5 / .22 BB Pellets': { barrel: '3.5"', caliber: '.22 BB Pellets' },
    'Crosman_38T-6 / .177 BB Pellets': { barrel: '6"', caliber: '.177 BB Pellets' },
    'Crosman_38T-6 / .22 BB Pellets': { barrel: '6"', caliber: '.22 BB Pellets' },
    'Crosman_454': { barrel: '6"', caliber: '.177 BB Pellets' },
    'Crosman_Single Action 6': { barrel: '4.25"', caliber: '.22 BB Pellets' },
    'CZ_75': { barrel: '4.75"', caliber: '9mm' },
    'CZ_75 B-4.7 / .40 S&W': { barrel: '4.7"', caliber: '.40 S&W' },
    'CZ_75 B-4.7 / 9 mm': { barrel: '4.7"', caliber: '9mm' },
    'CZ_75 B-4.7 / 9x21 mm': { barrel: '4.7"', caliber: '9x21mm' },
    'CZ_75 Compact (Railed)-3.9 / .40 S&W': { barrel: '3.9"', caliber: '.40 S&W' },
    'CZ_75 Compact (Railed)-3.9 / 9 mm': { barrel: '3.9"', caliber: '9mm' },
    'CZ_75 D PCR Compact': { barrel: '3.9"', caliber: '9mm' },
    'CZ_83-3.8 / .32 ACP': { barrel: '3.8"', caliber: '.32 ACP' },
    'CZ_83-3.8 / .380 ACP': { barrel: '3.8"', caliber: '.380 ACP' },
    'CZ_97 B': { barrel: '4.8"', caliber: '.45 ACP' },
    'CZ_P-01': { barrel: '3.9"', caliber: '9mm' },
    'CZ_P-07': { barrel: '3.75"', caliber: '9mm' },
    'CZ_P-07 Duty-3.8 / .40 S&W': { barrel: '3.8"', caliber: '.40 S&W' },
    'CZ_P-07 Duty-3.8 / 9 mm': { barrel: '3.8"', caliber: '9mm' },
    'CZ_P-09-4.53 / .40 S&W': { barrel: '4.53"', caliber: '.40 S&W' },
    'CZ_P-09-4.53 / 9 mm': { barrel: '4.53"', caliber: '9mm' },
    'CZ_P-10 C-4.02 / .40 S&W': { barrel: '4.02"', caliber: '.40 S&W' },
    'CZ_P-10 C-4.02 / 9 mm': { barrel: '4.02"', caliber: '9mm' },
    'CZ_P-10 S': { barrel: '3.5"', caliber: '9mm' },
    'CZ_Shadow 2': { barrel: '4.89"', caliber: '9mm' },
    'Dan Wesson_15-2': { barrel: '8"', caliber: '.357 Mag' },
    'Dan Wesson_15-2H': { barrel: '8"', caliber: '.357 Mag' },
    'Dan Wesson_15-2V': { barrel: '8"', caliber: '.357 Mag' },
    'Dan Wesson_15-2VH': { barrel: '8"', caliber: '.357 Mag' },
    'Davis Derringer_D25': { barrel: '2.5"', caliber: '.25 ACP' },
    'Davis Derringer_D32-2.25 / .32 ACP': { barrel: '2.25"', caliber: '.32 ACP' },
    'Davis Derringer_D32-2.5 / .32 ACP': { barrel: '2.5"', caliber: '.32 ACP' },
    'Davis Derringer_P32-2 / .32 ACP': { barrel: '2"', caliber: '.32 ACP' },
    'Davis Derringer_P32-3 / .32 ACP': { barrel: '3"', caliber: '.32 ACP' },
    'Diamondback_DB380-2.8 / .380 ACP': { barrel: '2.8"', caliber: '.380 ACP' },
    'Diamondback_DB380-3 / .380 ACP': { barrel: '3"', caliber: '.380 ACP' },
    'Diamondback_DB380 Gen 4': { barrel: '2.8"', caliber: '.380 ACP' },
    'Diamondback_DB9': { barrel: '3"', caliber: '9mm' },
    'Diamondback_DB9 Gen 4': { barrel: '3.1"', caliber: '9mm' },
    'EAA_Large Bore Bounty Hunter-4.5 / .357 Mag': { barrel: '4.5"', caliber: '.357 Mag' },
    'EAA_Large Bore Bounty Hunter-4.5 / .44 Mag': { barrel: '4.5"', caliber: '.44 Mag' },
    'EAA_Large Bore Bounty Hunter-4.5 / .45 Colt': { barrel: '4.5"', caliber: '.45 Colt' },
    'EAA_Large Bore Bounty Hunter-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'EAA_Large Bore Bounty Hunter-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'EAA_Large Bore Bounty Hunter-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'EAA_Small Bore Bounty Hunter-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'EAA_Small Bore Bounty Hunter-6.75 / .22 LR': { barrel: '6.75"', caliber: '.22 LR' },
    'EAA_Witness-4.5 / .40 S&W': { barrel: '4.5"', caliber: '.40 S&W' },
    'EAA_Witness-4.5 / 9 mm': { barrel: '4.5"', caliber: '9mm' },
    'EAA_Witness Compact-3.6 / .40 S&W': { barrel: '3.6"', caliber: '.40 S&W' },
    'EAA_Witness Compact-3.6 / .45 ACP': { barrel: '3.6"', caliber: '.45 ACP' },
    'EAA_Witness Compact-3.6 / 10 mm': { barrel: '3.6"', caliber: '10mm' },
    'EAA_Witness Compact-3.6 / 9 mm': { barrel: '3.6"', caliber: '9mm' },
    'EMF_Dakota SAA-4.75 / .45 Colt': { barrel: '4.75"', caliber: '.45 Colt' },
    'EMF_Dakota SAA-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'EMF_Dakota SAA-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'EMF_Hartford Express-4.75 / .45 Colt': { barrel: '4.75"', caliber: '.45 Colt' },
    'EMF_Hartford Express-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'EMF_Hartford Pinkerton': { barrel: '4"', caliber: '.45 Long Colt' },
    'EMF_Hartford Six Shooter-4.75 / .45 Long Colt': { barrel: '4.75"', caliber: '.45 Long Colt' },
    'EMF_Hartford Six Shooter-5.5 / .357 Mag': { barrel: '5.5"', caliber: '.357 Mag' },
    'EMF_Hartford Six Shooter-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'EMF_Hartford Six Shooter-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'EMF_Hartford Six Shooter-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'FEG_PMK-380': { barrel: '4"', caliber: '.380 ACP' },
    'FEG_SMC-380': { barrel: '4"', caliber: '.380 ACP' },
    'FN_509-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'FN_509-4.5 / 9 mm': { barrel: '4.5"', caliber: '9mm' },
    'FN_509 LS EDGE': { barrel: '5"', caliber: '9mm' },
    'FN_510 Tactical': { barrel: '4.71"', caliber: '10mm' },
    'FN_Five-seveN': { barrel: '4.75"', caliber: '5.7x28mm' },
    'FN_FNS-40': { barrel: '4"', caliber: '.40 S&W' },
    'FN_FNS-40 Long Slide': { barrel: '5"', caliber: '.40 S&W' },
    'FN_FNS-9': { barrel: '4"', caliber: '9mm' },
    'FN_FNX-45 Tactical': { barrel: '5.3"', caliber: '.45 ACP' },
    'FN_FNX-9': { barrel: '4"', caliber: '9mm' },
    'FN_Reflex': { barrel: '3.3"', caliber: '9mm' },
    'FN_Reflex MRD': { barrel: '3.3"', caliber: '9mm' },
    'Freedom Arms_353 Field Grade-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Freedom Arms_353 Field Grade-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'Freedom Arms_454 Casull Field Grade-4.75 / Multiple Calibers': { barrel: '4.75"', caliber: 'Multiple Calibers' },
    'Freedom Arms_454 Casull Field Grade-6 / Multiple Calibers': { barrel: '6"', caliber: 'Multiple Calibers' },
    'Freedom Arms_454 Casull Field Grade-7.5 / Multiple Calibers': { barrel: '7.5"', caliber: 'Multiple Calibers' },
    'Freedom Arms_455 Premier Grade-4.75 / Multiple Calibers': { barrel: '4.75"', caliber: 'Multiple Calibers' },
    'Freedom Arms_455 Premier Grade-6 / Multiple Calibers': { barrel: '6"', caliber: 'Multiple Calibers' },
    'Freedom Arms_455 Premier Grade-7.5 / Multiple Calibers': { barrel: '7.5"', caliber: 'Multiple Calibers' },
    'Glock_17 (All Generations)': { barrel: '4.5"', caliber: '9mm' },
    'Glock_19 (All Generations)': { barrel: '4"', caliber: '9mm' },
    'Glock_19X (All Generations)': { barrel: '4"', caliber: '9mm' },
    'Glock_20 (All Generations)': { barrel: '4.6"', caliber: '10mm' },
    'Glock_20SF (All Generations)': { barrel: '4.6"', caliber: '10mm' },
    'Glock_21 (All Generations)': { barrel: '4.6"', caliber: '.45 ACP' },
    'Glock_22 (All Generations)': { barrel: '4.5"', caliber: '.40 S&W' },
    'Glock_23 (All Generations)': { barrel: '4"', caliber: '.40 S&W' },
    'Glock_26 (All Generations)': { barrel: '3.46"', caliber: '9mm' },
    'Glock_27 (All Generations)': { barrel: '3.46"', caliber: '9mm' },
    'Glock_29 (All Generations)': { barrel: '3.78"', caliber: '10mm' },
    'Glock_30 (All Generations)': { barrel: '3.78"', caliber: '.45 ACP' },
    'Glock_30S (All Generations)': { barrel: '3.78"', caliber: '.45 ACP' },
    'Glock_30SF (All Generations)': { barrel: '3.78"', caliber: '.45 ACP' },
    'Glock_31 (All Generations)': { barrel: '4.5"', caliber: '.357 SIG' },
    'Glock_32 (All Generations)': { barrel: '4"', caliber: '.357 SIG' },
    'Glock_34 (All Generations)': { barrel: '5.32"', caliber: '9mm' },
    'Glock_35 (All Generations)': { barrel: '5.32"', caliber: '.40 S&W' },
    'Glock_36 (All Generations)': { barrel: '3.78"', caliber: '.45 ACP' },
    'Glock_40 MOS (All Generations)': { barrel: '6.02"', caliber: '10mm' },
    'Glock_41 (All Generations)': { barrel: '5.31"', caliber: '.45 ACP' },
    'Glock_42 (All Generations)': { barrel: '3.25"', caliber: '.380 ACP' },
    'Glock_43 (All Generations)': { barrel: '3.39"', caliber: '9mm' },
    'Glock_43X (All Generations)': { barrel: '3.41"', caliber: '9mm' },
    'Glock_43X MOS (All Generations)': { barrel: '3.41"', caliber: '9mm' },
    'Glock_45 (All Generations)': { barrel: '4"', caliber: '9mm' },
    'Glock_45 MOS (All Generations)': { barrel: '4.02"', caliber: '9mm' },
    'Glock_47 (All Generations)': { barrel: '4.5"', caliber: '9mm' },
    'Glock_47 MOS (All Generations)': { barrel: '4.5"', caliber: '9mm' },
    'Glock_48 (All Generations)': { barrel: '4.17"', caliber: '9mm' },
    'Glock_48 MOS (All Generations)': { barrel: '4.17"', caliber: '9mm' },
    'Great Western_Deputy-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Great Western_Deputy-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Great Western_Deputy-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Great Western_Single Action-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Great Western_Single Action-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Great Western_Single Action-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Great Western_Single Action-4.75 / .38 Special': { barrel: '4.75"', caliber: '.38 Special' },
    'Great Western_Single Action-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Great Western_Single Action-5.5 / .38 Special': { barrel: '5.5"', caliber: '.38 Special' },
    'Great Western_Single Action-7.5 / .22 LR': { barrel: '7.5"', caliber: '.22 LR' },
    'Great Western_Single Action-7.5 / .38 Special': { barrel: '7.5"', caliber: '.38 Special' },
    'H&R_622-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'H&R_622-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_622-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'H&R_632 Guardsman-2.5 / .32 S&W': { barrel: '2.5"', caliber: '.32 S&W' },
    'H&R_632 Guardsman-4 / .32 S&W': { barrel: '4"', caliber: '.32 S&W' },
    'H&R_660 Gunfighter': { barrel: '6"', caliber: '.22 LR' },
    'H&R_676-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'H&R_676-4.5 / .22 WMR': { barrel: '4.5"', caliber: '.22 WMR' },
    'H&R_676-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'H&R_676-5.5 / .22 WMR': { barrel: '5.5"', caliber: '.22 WMR' },
    'H&R_676-7.5 / .22 LR': { barrel: '7.5"', caliber: '.22 LR' },
    'H&R_676-7.5 / .22 WMR': { barrel: '7.5"', caliber: '.22 WMR' },
    'H&R_686-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'H&R_686-4.5 / .22 WMR': { barrel: '4.5"', caliber: '.22 WMR' },
    'H&R_732 Guardsman-2.5 / .32 S&W': { barrel: '2.5"', caliber: '.32 S&W' },
    'H&R_732 Guardsman-2.5 / .32 S&W Long': { barrel: '2.5"', caliber: '.32 S&W Long' },
    'H&R_732 Guardsman-4 / .32 S&W': { barrel: '4"', caliber: '.32 S&W' },
    'H&R_732 Guardsman-4 / .32 S&W Long': { barrel: '4"', caliber: '.32 S&W Long' },
    'H&R_733 Guardsman-2.5 / .32 S&W': { barrel: '2.5"', caliber: '.32 S&W' },
    'H&R_733 Guardsman-2.5 / .32 S&W Long': { barrel: '2.5"', caliber: '.32 S&W Long' },
    'H&R_900-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'H&R_900-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_900-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'H&R_901-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'H&R_901-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_901-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'H&R_922-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_922-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'H&R_922 Bantam Weight': { barrel: '2.5"', caliber: '.22 LR' },
    'H&R_925 Defender-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'H&R_925 Defender-2.5 / .38 S&W': { barrel: '2.5"', caliber: '.38 S&W' },
    'H&R_925 Defender-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_925 Defender-4 / .38 S&W': { barrel: '4"', caliber: '.38 S&W' },
    'H&R_926-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_926-4 / .38 S&W': { barrel: '4"', caliber: '.38 S&W' },
    'H&R_929 Sidekick-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'H&R_929 Sidekick-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'H&R_929 Sidekick-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'H&R_930': { barrel: '4"', caliber: '.22 LR' },
    'H&R_939 Ultra Sidekick': { barrel: '6"', caliber: '.22 LR' },
    'H&R_940': { barrel: '6"', caliber: '.22 LR' },
    'H&R_949': { barrel: '5.5"', caliber: '.22 LR' },
    'H&R_950': { barrel: '5.5"', caliber: '.22 LR' },
    'H&R_960': { barrel: '2.5"', caliber: '.32 Blank' },
    'H&R_970': { barrel: '2.5"', caliber: '.22 Blank' },
    'H&R_999 Sportsman': { barrel: '6"', caliber: '.22 LR' },
    'H&R_HK-4': { barrel: '3.5"', caliber: 'Multiple Calibers' },
    'Hawes_Chief Marshal 6357CM': { barrel: '6"', caliber: '.357 Mag' },
    'Hawes_Chief Marshal 645CM': { barrel: '6"', caliber: '.45 Long Colt' },
    'Hawes_Deputy Marshal 621': { barrel: '4.75"', caliber: '.22 LR' },
    'Hawes_Deputy Marshal 621C': { barrel: '4.75"', caliber: '.22 LR' },
    'Hawes_Deputy Marshal 621T': { barrel: '4.75"', caliber: '.22 LR' },
    'Hawes_Medallion': { barrel: '4"', caliber: '.38 Special' },
    'Hawes_Montana Marshal 623B': { barrel: '5.5"', caliber: '.22 LR' },
    'Hawes_Montana Marshal 623BC-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Hawes_Montana Marshal 623BC-5.5 / .22 Mag': { barrel: '5.5"', caliber: '.22 Mag' },
    'Hawes_Montana Marshal 6357B': { barrel: '6"', caliber: '.357 Mag' },
    'Hawes_Texas Marshal 623T': { barrel: '5.5"', caliber: '.22 LR' },
    'Hawes_Texas Marshal 6357CM': { barrel: '6"', caliber: '.357 Mag' },
    'Hawes_Texas Marshal 644T': { barrel: '6"', caliber: '.44 Mag' },
    'Hawes_Texas Marshal 645T': { barrel: '6"', caliber: '.45 Long Colt' },
    'Hawes_Trophy': { barrel: '6"', caliber: '.38 Special' },
    'Hawes_Virginia City Marshal 644V': { barrel: '6"', caliber: '.44 Mag' },
    'Hawes_Virginia City Marshal 645V': { barrel: '6"', caliber: '.45 Long Colt' },
    'Hawes_Western Derringer-3 / .22 Calibers': { barrel: '3"', caliber: '.22 Calibers' },
    'Hawes_Western Derringer-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Hawes_Western Marshal 623': { barrel: '5.5"', caliber: '.22 LR' },
    'Hawes_Western Marshal 623C-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Hawes_Western Marshal 623C-5.5 / .22 Mag': { barrel: '5.5"', caliber: '.22 Mag' },
    'Hawes_Western Marshal 623M': { barrel: '5.5"', caliber: '.22 Mag' },
    'Hawes_Western Marshal 6357': { barrel: '6"', caliber: '.357 Mag' },
    'Hawes_Western Marshal 6357C': { barrel: '6"', caliber: '.357 Mag' },
    'Hawes_Western Marshal 644': { barrel: '6"', caliber: '.44 Mag' },
    'Hawes_Western Marshal 644C': { barrel: '6"', caliber: '.44 Mag' },
    'Hawes_Western Marshal 645': { barrel: '6"', caliber: '.45 Long Colt' },
    'Hawes_Western Marshal 645C': { barrel: '6"', caliber: '.45 Long Colt' },
    'Heckler & Koch_CC9': { barrel: '3.32"', caliber: '9mm' },
    'Heckler & Koch_HK45 Compact': { barrel: '3.94"', caliber: '.45 ACP' },
    'Heckler & Koch_P30-3.86 / .40 S&W': { barrel: '3.86"', caliber: '.40 S&W' },
    'Heckler & Koch_P30-3.86 / 9 mm': { barrel: '3.86"', caliber: '9mm' },
    'Heckler & Koch_P30L-4.44 / .40 S&W': { barrel: '4.44"', caliber: '.40 S&W' },
    'Heckler & Koch_P30L-4.44 / 9 mm': { barrel: '4.44"', caliber: '9mm' },
    'Heckler & Koch_P30SK': { barrel: '3.27"', caliber: '9mm' },
    'Heckler & Koch_P7 M8': { barrel: '4.13"', caliber: '9mm' },
    'Heckler & Koch_USP-4.25 / .40 S&W': { barrel: '4.25"', caliber: '.40 S&W' },
    'Heckler & Koch_USP-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Heckler & Koch_USP-4.41 / .45 ACP': { barrel: '4.41"', caliber: '.45 ACP' },
    'Heckler & Koch_USP Compact-3.58 / .40 S&W': { barrel: '3.58"', caliber: '.40 S&W' },
    'Heckler & Koch_USP Compact-3.58 / 9 mm': { barrel: '3.58"', caliber: '9mm' },
    'Heckler & Koch_USP Compact-3.78 / .45 ACP': { barrel: '3.78"', caliber: '.45 ACP' },
    'Heckler & Koch_USP9-4.25 / .40 S&W': { barrel: '4.25"', caliber: '.40 S&W' },
    'Heckler & Koch_USP9-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Heckler & Koch_VP9': { barrel: '4.09"', caliber: '9mm' },
    'Heckler & Koch_VP9 SK': { barrel: '3.39"', caliber: '9mm' },
    'Heckler & Koch_VP9A1 K': { barrel: '4.09"', caliber: '9mm' },
    'Heritage_Rough Rider-3.5 / .22 LR / .22 WMR': { barrel: '3.5"', caliber: '.22 LR / .22 WMR' },
    'Heritage_Rough Rider-4.75 / .22 LR / .22 WMR': { barrel: '4.75"', caliber: '.22 LR / .22 WMR' },
    'Heritage_Rough Rider-6.5 / .22 LR / .22 WMR': { barrel: '6.5"', caliber: '.22 LR / .22 WMR' },
    'Heritage_Rough Rider-9 / .22 LR / .22 WMR': { barrel: '9"', caliber: '.22 LR / .22 WMR' },
    'High Standard_Double Nine': { barrel: '5.5"', caliber: '.22 Calibers' },
    'High Standard_Dura-Matic M-100-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'High Standard_Dura-Matic M-100-6.5 / .22 LR': { barrel: '6.5"', caliber: '.22 LR' },
    'High Standard_Durango-4.5 / .22 Calibers': { barrel: '4.5"', caliber: '.22 Calibers' },
    'High Standard_Durango-5.5 / .22 Calibers': { barrel: '5.5"', caliber: '.22 Calibers' },
    'High Standard_Field King-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'High Standard_Field King-6.75 / .22 LR': { barrel: '6.75"', caliber: '.22 LR' },
    'High Standard_Flite King LW-100-4.5 / .22 Short': { barrel: '4.5"', caliber: '.22 Short' },
    'High Standard_Flite King LW-100-6.75 / .22 Short': { barrel: '6.75"', caliber: '.22 Short' },
    'High Standard_High Sierra': { barrel: '7"', caliber: '.22 Calibers' },
    'High Standard_Hombre': { barrel: '4.5"', caliber: '.22 Calibers' },
    'High Standard_Longhorn-4.5 / .22 Calibers': { barrel: '4.5"', caliber: '.22 Calibers' },
    'High Standard_Longhorn-5.5 / .22 Calibers': { barrel: '5.5"', caliber: '.22 Calibers' },
    'High Standard_Longhorn-9.5 / .22 Calibers': { barrel: '9.5"', caliber: '.22 Calibers' },
    'High Standard_Natchez': { barrel: '4.5"', caliber: '.22 Calibers' },
    'High Standard_Olympic-4.5 / .22 Short': { barrel: '4.5"', caliber: '.22 Short' },
    'High Standard_Olympic-6.75 / .22 Short': { barrel: '6.75"', caliber: '.22 Short' },
    'High Standard_Posse': { barrel: '3.5"', caliber: '.22 Calibers' },
    'High Standard_Sentinel-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'High Standard_Sentinel-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'High Standard_Sharpshooter': { barrel: '5.5"', caliber: '.22 LR' },
    'High Standard_Sport King-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'High Standard_Sport King-6.75 / .22 LR': { barrel: '6.75"', caliber: '.22 LR' },
    'High Standard_Supermatic-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'High Standard_Supermatic-6.75 / .22 LR': { barrel: '6.75"', caliber: '.22 LR' },
    'High Standard_Supermatic Citation Military (Bull Barrel)': { barrel: '5.5"', caliber: '.22 LR' },
    'Honor Defense_Honor Guard SC FIST': { barrel: '3.375"', caliber: '9mm' },
    'I.N.A._Tiger-2.25 / .38 Special': { barrel: '2.25"', caliber: '.38 Special' },
    'I.N.A._Tiger-3.25 / .38 Special': { barrel: '3.25"', caliber: '.38 Special' },
    'Interarms_Virginian Dragoon-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Interarms_Virginian Dragoon-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Interarms_Virginian Dragoon-8.375 / .44 Mag': { barrel: '8.375"', caliber: '.44 Mag' },
    'Iver Johnson_American Bulldog-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'Iver Johnson_American Bulldog-2.5 / .22 Mag': { barrel: '2.5"', caliber: '.22 Mag' },
    'Iver Johnson_American Bulldog-2.5 / .38 Special': { barrel: '2.5"', caliber: '.38 Special' },
    'Iver Johnson_American Bulldog-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Iver Johnson_American Bulldog-4 / .22 Mag': { barrel: '4"', caliber: '.22 Mag' },
    'Iver Johnson_American Bulldog-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Iver Johnson_Cadet 55S-A-2.5 / .22 LR': { barrel: '2.5"', caliber: '.22 LR' },
    'Iver Johnson_Cadet 55S-A-2.5 / .22 Mag': { barrel: '2.5"', caliber: '.22 Mag' },
    'Iver Johnson_Cadet 55S-A-2.5 / .32 S&W': { barrel: '2.5"', caliber: '.32 S&W' },
    'Iver Johnson_Cadet 55S-A-2.5 / .38 S&W': { barrel: '2.5"', caliber: '.38 S&W' },
    'Iver Johnson_Cadet 55S-A-2.5 / .38 Special': { barrel: '2.5"', caliber: '.38 Special' },
    'Iver Johnson_Cattleman-4.75 / .357 Mag': { barrel: '4.75"', caliber: '.357 Mag' },
    'Iver Johnson_Cattleman-4.75 / .44 Mag': { barrel: '4.75"', caliber: '.44 Mag' },
    'Iver Johnson_Cattleman-4.75 / .45 Long Colt': { barrel: '4.75"', caliber: '.45 Long Colt' },
    'Iver Johnson_Cattleman-5.5 / .357 Mag': { barrel: '5.5"', caliber: '.357 Mag' },
    'Iver Johnson_Cattleman-5.5 / .45 Long Colt': { barrel: '5.5"', caliber: '.45 Long Colt' },
    'Iver Johnson_Cattleman-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Iver Johnson_Cattleman-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'Iver Johnson_Cattleman-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Iver Johnson_Cattleman-7.5 / .45 Long Colt': { barrel: '7.5"', caliber: '.45 Long Colt' },
    'Iver Johnson_Cattleman Buckhorn Magnum-4.75 / .44 Mag': { barrel: '4.75"', caliber: '.44 Mag' },
    'Iver Johnson_Cattleman Buckhorn Magnum-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Iver Johnson_Cattleman Buckhorn Magnum-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'Iver Johnson_Cattleman Buckhorn Magnum-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Iver Johnson_Cattleman Buckhorn Magnum-7.5 / .45 Long Colt': { barrel: '7.5"', caliber: '.45 Long Colt' },
    'Iver Johnson_Cattleman Trailblazer-5.5 / .22 Calibers': { barrel: '5.5"', caliber: '.22 Calibers' },
    'Iver Johnson_Cattleman Trailblazer-6.5 / .22 Calibers': { barrel: '6.5"', caliber: '.22 Calibers' },
    'Iver Johnson_Rookie': { barrel: '4"', caliber: '.38 Special' },
    'Iver Johnson_Sidewinder-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Iver Johnson_Sidewinder-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Iver Johnson_Sportsman-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Iver Johnson_Sportsman-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Iver Johnson_Starter-2 / .22 Blank': { barrel: '2"', caliber: '.22 Blank' },
    'Iver Johnson_Starter-2 / .32 Blank': { barrel: '2"', caliber: '.32 Blank' },
    'Iver Johnson_Target-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Iver Johnson_Target-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'IWI_Masada': { barrel: '4.1"', caliber: '9mm' },
    'J.C. Higgins_Model 80-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'J.C. Higgins_Model 80-6.5 / .22 LR': { barrel: '6.5"', caliber: '.22 LR' },
    'J.C. Higgins_Model 88-4.5 / .22 LR': { barrel: '4.5"', caliber: '.22 LR' },
    'J.C. Higgins_Model 88-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'J.C. Higgins_Ranger': { barrel: '5.5"', caliber: '.22 Calibers' },
    'Jennings_J22': { barrel: '2.5"', caliber: '.22 LR' },
    'Jennings_J25': { barrel: '2.5"', caliber: '.25 ACP' },
    'Kahr Arms_CW9': { barrel: '3.6"', caliber: '9mm' },
    'Kahr Arms_K9': { barrel: '3.6"', caliber: '9mm' },
    'Kahr Arms_P380': { barrel: '2.5"', caliber: '.380 ACP' },
    'KBI_Model 1911 A-1': { barrel: '5"', caliber: '.45 ACP' },
    'KBI_PSP-25': { barrel: '2"', caliber: '.25 ACP' },
    'KelTec_P32': { barrel: '2.7"', caliber: '.32 ACP' },
    'KelTec_PF-9': { barrel: '3.1"', caliber: '9mm' },
    'Kimber_Compact CDP II': { barrel: '4"', caliber: '.45 ACP' },
    'Kimber_Custom-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Kimber_Custom-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Kimber_Custom CDP II': { barrel: '5"', caliber: '.45 ACP' },
    'Kimber_Custom II-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Kimber_Custom II-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Kimber_Custom Royale': { barrel: '5"', caliber: '.45 ACP' },
    'Kimber_Eclipse Custom II-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Kimber_Eclipse Custom II-5 / 10 mm': { barrel: '5"', caliber: '10mm' },
    'Kimber_Gold Match': { barrel: '5"', caliber: '.45 ACP' },
    'Kimber_Micro 9': { barrel: '3.15"', caliber: '9mm' },
    'Kimber_Pro Carry II-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Kimber_Pro Carry II-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Kimber_R7 Mako': { barrel: '3.37"', caliber: '9mm' },
    'Kimber_Solo Carry': { barrel: '2.7"', caliber: '9mm' },
    'Kimber_Ultra Carry II-3 / .45 ACP': { barrel: '3"', caliber: '.45 ACP' },
    'Kimber_Ultra Carry II-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Kimber_Ultra CDP II': { barrel: '3"', caliber: '.45 ACP' },
    'Llama_IIIA': { barrel: '3.7"', caliber: '.380 ACP' },
    'Llama_IX-A': { barrel: '5.125"', caliber: '.45 ACP' },
    'Llama_VIII': { barrel: '5"', caliber: '.38 Super' },
    'Llama_XA': { barrel: '3.7"', caliber: '.32 ACP' },
    'Llama_XV': { barrel: '3.7"', caliber: '.22 LR' },
    'Luger_Erma LA 22': { barrel: '4.5"', caliber: '.22 LR' },
    'Magnum Research_Desert Eagle (No Rail)-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Magnum Research_Desert Eagle (No Rail)-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Magnum Research_Desert Eagle (No Rail)-6 / .50 Action Express': { barrel: '6"', caliber: '.50 Action Express' },
    'Makarov_Makarov': { barrel: '3.75"', caliber: '9mm Police' },
    'Mossberg_MC2c': { barrel: '3.9"', caliber: '9mm' },
    'Mossberg_MC2sc': { barrel: '3.4"', caliber: '9mm' },
    'Navy Arms_1873 Single Action Army-4.75 / .44-40 WCF': { barrel: '4.75"', caliber: '.44-40 WCF' },
    'Navy Arms_1873 Single Action Army-5.5 / .44-40 WCF': { barrel: '5.5"', caliber: '.44-40 WCF' },
    'Navy Arms_1873 Single Action Army-7.5 / .44-40 WCF': { barrel: '7.5"', caliber: '.44-40 WCF' },
    'Navy Arms_1894 Bisley Single Action-4.75 / .45 Colt': { barrel: '4.75"', caliber: '.45 Colt' },
    'Navy Arms_1894 Bisley Single Action-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'Navy Arms_1894 Bisley Single Action-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'Nighthawk_BDS9 Commander': { barrel: '4.25"', caliber: '9mm' },
    'Nighthawk_Talon': { barrel: '5"', caliber: '.45 ACP' },
    'Norinco_1911 A-1': { barrel: '5"', caliber: '.45 ACP' },
    'Norinco_M-59': { barrel: '3.75"', caliber: '9mm Makarov' },
    'Norinco_Tokarev': { barrel: '4.5"', caliber: '9mm' },
    'Para_Ordnance-P14': { barrel: '5"', caliber: '.45 ACP' },
    'Para_Ordnance-P15': { barrel: '4.25"', caliber: '.40 S&W' },
    'Para_Ordnance-P16-5 / .40 S&W': { barrel: '5"', caliber: '.40 S&W' },
    'Para_Ordnance-P16-5 / 10 mm': { barrel: '5"', caliber: '10mm' },
    'PSA_5.7 Rock': { barrel: '5.2"', caliber: '5.7x28mm' },
    'PSA_Dagger Compact': { barrel: '3.9"', caliber: '9mm' },
    'PSA_Dagger Full Size (Threaded)': { barrel: '4.5"', caliber: '9mm' },
    'Ram Line_Exactor': { barrel: '8"', caliber: '.22 LR' },
    'Rock Island Armory_TAC Ultra CS-3.62 / .45 ACP': { barrel: '3.62"', caliber: '.45 ACP' },
    'Rock Island Armory_TAC Ultra CS-3.62 / 9 mm': { barrel: '3.62"', caliber: '9mm' },
    'Rock Island Armory_TAC Ultra MS HC': { barrel: '4.2"', caliber: '9mm / .22 TCM' },
    'Rohm_RG-42': { barrel: '2.75"', caliber: '.25 ACP' },
    'Rossi_All Double Action Revolvers-2 / .357 Mag': { barrel: '2"', caliber: '.357 Mag' },
    'Rossi_All Double Action Revolvers-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Rossi_All Double Action Revolvers-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Rossi_All Double Action Revolvers-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Ruger_5.7': { barrel: '4.95"', caliber: '5.7x28mm' },
    'Ruger_Alaskan-2.5 / .44 Mag': { barrel: '2.5"', caliber: '.44 Mag' },
    'Ruger_Alaskan-2.5 / .454 Casull': { barrel: '2.5"', caliber: '.454 Casull' },
    'Ruger_Alaskan-2.5 / .480 Ruger': { barrel: '2.5"', caliber: '.480 Ruger' },
    'Ruger_American-4.2 / .40 S&W': { barrel: '4.2"', caliber: '.40 S&W' },
    'Ruger_American-4.2 / 9 mm': { barrel: '4.2"', caliber: '9mm' },
    'Ruger_American-4.5 / .45 ACP': { barrel: '4.5"', caliber: '.45 ACP' },
    'Ruger_Bearcat': { barrel: '4.2"', caliber: '.22 LR' },
    'Ruger_Blackhawk-10 / .357 Mag': { barrel: '10"', caliber: '.357 Mag' },
    'Ruger_Blackhawk-10 / .44 Mag': { barrel: '10"', caliber: '.44 Mag' },
    'Ruger_Blackhawk-4.625 / .357 Mag': { barrel: '4.625"', caliber: '.357 Mag' },
    'Ruger_Blackhawk-4.625 / .41 Mag': { barrel: '4.625"', caliber: '.41 Mag' },
    'Ruger_Blackhawk-4.625 / .44 Mag': { barrel: '4.625"', caliber: '.44 Mag' },
    'Ruger_Blackhawk-4.625 / .45 ACP': { barrel: '4.625"', caliber: '.45 ACP' },
    'Ruger_Blackhawk-6.5 / .357 Mag': { barrel: '6.5"', caliber: '.357 Mag' },
    'Ruger_Blackhawk-6.5 / .41 Mag': { barrel: '6.5"', caliber: '.41 Mag' },
    'Ruger_Blackhawk-6.5 / .44 Mag': { barrel: '6.5"', caliber: '.44 Mag' },
    'Ruger_Blackhawk-7.5 / .357 Mag': { barrel: '7.5"', caliber: '.357 Mag' },
    'Ruger_Blackhawk-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Ruger_Blackhawk Convertible-4.625 / .357 Mag / 9 mm': { barrel: '4.625"', caliber: '.357 Mag / 9mm' },
    'Ruger_Blackhawk Convertible-4.625 / .45 Colt / .45 ACP': { barrel: '4.625"', caliber: '.45 Colt / .45 ACP' },
    'Ruger_EC9s': { barrel: '3.12"', caliber: '9mm' },
    'Ruger_GP100-3 / .327 Fed': { barrel: '3"', caliber: '.327 Fed' },
    'Ruger_GP100-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Ruger_GP100-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Ruger_GP100-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Ruger_GP100-4.2 / .357 Mag': { barrel: '4.2"', caliber: '.357 Mag' },
    'Ruger_GP100-4.2 / .38 Special': { barrel: '4.2"', caliber: '.38 Special' },
    'Ruger_GP100-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Ruger_GP100-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Ruger_Hawkeye': { barrel: '8.5"', caliber: '.256 WMR' },
    'Ruger_KMK4': { barrel: '4.75"', caliber: '.22 LR' },
    'Ruger_KMK512': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_KMK678': { barrel: '6.875"', caliber: '.22 LR' },
    'Ruger_LC9': { barrel: '3.12"', caliber: '9mm' },
    'Ruger_LC9s': { barrel: '3.12"', caliber: '9mm' },
    'Ruger_LCP': { barrel: '2.75"', caliber: '.380 ACP' },
    'Ruger_LCP II-2.75 / .22 LR': { barrel: '2.75"', caliber: '.22 LR' },
    'Ruger_LCP II-2.75 / .380 ACP': { barrel: '2.75"', caliber: '.380 ACP' },
    'Ruger_LCP MAX': { barrel: '2.8"', caliber: '.380 ACP' },
    'Ruger_LCR': { barrel: '1.87"', caliber: '.38 Special' },
    'Ruger_LCRx-3 / .22 LR': { barrel: '3"', caliber: '.22 LR' },
    'Ruger_LCRx-3 / .22 WMR': { barrel: '3"', caliber: '.22 WMR' },
    'Ruger_LCRx-3 / .327 Fed': { barrel: '3"', caliber: '.327 Fed' },
    'Ruger_LCRx-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Ruger_LCRx-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Ruger_LCRx-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Ruger_Mark I-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Ruger_Mark I-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Mark I-6.875 / .22 LR': { barrel: '6.875"', caliber: '.22 LR' },
    'Ruger_Mark II-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Ruger_Mark II-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Mark II-6.875 / .22 LR': { barrel: '6.875"', caliber: '.22 LR' },
    'Ruger_Mark II (Bull Barrel)': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Mark III-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Ruger_Mark III-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Mark III-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Ruger_Mark III-6.875 / .22 LR': { barrel: '6.875"', caliber: '.22 LR' },
    'Ruger_Mark IV-4.75 / .22 LR': { barrel: '4.75"', caliber: '.22 LR' },
    'Ruger_Mark IV-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Max-9': { barrel: '3.2"', caliber: '9mm' },
    'Ruger_MK512': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_MK678': { barrel: '6.875"', caliber: '.22 LR' },
    'Ruger_MK678G': { barrel: '6.875"', caliber: '.22 LR' },
    'Ruger_P85': { barrel: '4.5"', caliber: '9mm' },
    'Ruger_P89': { barrel: '4.5"', caliber: '9mm' },
    'Ruger_P90': { barrel: '4.5"', caliber: '.45 ACP' },
    'Ruger_P93': { barrel: '4"', caliber: '9mm' },
    'Ruger_P94': { barrel: '4.3"', caliber: '9mm' },
    'Ruger_P95': { barrel: '4"', caliber: '9mm' },
    'Ruger_P97': { barrel: '4.25"', caliber: '.45 ACP' },
    'Ruger_RDA 36 Security Six': { barrel: '6"', caliber: '.357 Mag' },
    'Ruger_Redhawk-5.5 / .357 Mag': { barrel: '5.5"', caliber: '.357 Mag' },
    'Ruger_Redhawk-5.5 / .44 Mag': { barrel: '5.5"', caliber: '.44 Mag' },
    'Ruger_Redhawk-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Ruger_RST4 Standard': { barrel: '4.75"', caliber: '.22 LR' },
    'Ruger_RXM': { barrel: '4"', caliber: '9mm' },
    'Ruger_Security Six-2.75 / .357 Mag': { barrel: '2.75"', caliber: '.357 Mag' },
    'Ruger_Security Six-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Ruger_Security Six-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Ruger_Security-380': { barrel: '3.42"', caliber: '.380 ACP' },
    'Ruger_Security-9': { barrel: '4"', caliber: '9mm' },
    'Ruger_Service Six-2.75 / .357 Mag': { barrel: '2.75"', caliber: '.357 Mag' },
    'Ruger_Service Six-2.75 / .38 Special': { barrel: '2.75"', caliber: '.38 Special' },
    'Ruger_Service Six-2.75 / 9 mm': { barrel: '2.75"', caliber: '9mm' },
    'Ruger_Single Six-4.625 / .22 LR': { barrel: '4.625"', caliber: '.22 LR' },
    'Ruger_Single Six-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Single Six-6.5 / .22 LR': { barrel: '6.5"', caliber: '.22 LR' },
    'Ruger_Single Six-9.5 / .22 LR': { barrel: '9.5"', caliber: '.22 LR' },
    'Ruger_SP101-2.25 / .357 Mag': { barrel: '2.25"', caliber: '.357 Mag' },
    'Ruger_SP101-2.25 / .38 Special': { barrel: '2.25"', caliber: '.38 Special' },
    'Ruger_SP101-2.25 / 9 mm': { barrel: '2.25"', caliber: '9mm' },
    'Ruger_SP101-3 / .327 Fed': { barrel: '3"', caliber: '.327 Fed' },
    'Ruger_SP101-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Ruger_SP101-4.2 / .22 LR': { barrel: '4.2"', caliber: '.22 LR' },
    'Ruger_SP101-4.2 / .327 Fed': { barrel: '4.2"', caliber: '.327 Fed' },
    'Ruger_SP101-4.2 / .357 Mag': { barrel: '4.2"', caliber: '.357 Mag' },
    'Ruger_Speed Six-2.75 / .357 Mag': { barrel: '2.75"', caliber: '.357 Mag' },
    'Ruger_Speed Six-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Ruger_Speed Six-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Ruger_SR 1911': { barrel: '5"', caliber: '.45 ACP' },
    'Ruger_SR22': { barrel: '3.5"', caliber: '.22 LR' },
    'Ruger_SR40c': { barrel: '3.5"', caliber: '.40 S&W' },
    'Ruger_SR9': { barrel: '4.14"', caliber: '9mm' },
    'Ruger_SR9c': { barrel: '3.5"', caliber: '9mm' },
    'Ruger_Super Blackhawk-10.5 / .44 Mag': { barrel: '10.5"', caliber: '.44 Mag' },
    'Ruger_Super Blackhawk-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Ruger_Super Redhawk-7.5 / .44 Mag': { barrel: '7.5"', caliber: '.44 Mag' },
    'Ruger_Super Redhawk-7.5 / .454 Casull': { barrel: '7.5"', caliber: '.454 Casull' },
    'Ruger_Super Redhawk-7.5 / .480 Ruger': { barrel: '7.5"', caliber: '.480 Ruger' },
    'Ruger_Super Redhawk-7.5 / 10 mm': { barrel: '7.5"', caliber: '10mm' },
    'Ruger_Super Redhawk-9.5 / .22 Hornet': { barrel: '9.5"', caliber: '.22 Hornet' },
    'Ruger_Super Redhawk-9.5 / .44 Mag': { barrel: '9.5"', caliber: '.44 Mag' },
    'Ruger_Super Single Six-5.5 / .22 LR': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Super Single Six-6.5 / .22 LR': { barrel: '6.5"', caliber: '.22 LR' },
    'Ruger_Super Single Six-9.5 / .22 LR': { barrel: '9.5"', caliber: '.22 LR' },
    'Ruger_Super Wrangler': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Target T512 (Bull Barrel)': { barrel: '5.5"', caliber: '.22 LR' },
    'Ruger_Vaquero-5.5 / .357 Mag': { barrel: '5.5"', caliber: '.357 Mag' },
    'Ruger_Vaquero-5.5 / .45 Colt': { barrel: '5.5"', caliber: '.45 Colt' },
    'Ruger_Vaquero-7.5 / .45 Colt': { barrel: '7.5"', caliber: '.45 Colt' },
    'SAR_SAR9': { barrel: '4.4"', caliber: '9mm' },
    'Savage_Model 101': { barrel: '4"', caliber: '.22 LR' },
    'SCCY_CPX-1': { barrel: '3"', caliber: '9mm' },
    'SCCY_CPX-1 Gen2': { barrel: '3.1"', caliber: '9mm' },
    'SCCY_CPX-1 Gen3': { barrel: '3.1"', caliber: '9mm' },
    'SCCY_CPX-2 Gen2': { barrel: '3.1"', caliber: '9mm' },
    'SCCY_CPX-3': { barrel: '2.96"', caliber: '.380 ACP' },
    'SCCY_DVG-1': { barrel: '3.1"', caliber: '9mm' },
    'Sig Sauer_1911 Ultra Compact Tribal': { barrel: '3.3"', caliber: '.45 ACP' },
    'Sig Sauer_1911 XCarry': { barrel: '4.25"', caliber: '.45 ACP' },
    'Sig Sauer_1911R': { barrel: '5"', caliber: '.45 ACP' },
    'Sig Sauer_P220': { barrel: '4.4"', caliber: '.45 ACP' },
    'Sig Sauer_P225': { barrel: '3.9"', caliber: '9mm' },
    'Sig Sauer_P226-4.4 / .357 SIG': { barrel: '4.4"', caliber: '.357 SIG' },
    'Sig Sauer_P226-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 DAK-4.4 / .357 SIG': { barrel: '4.4"', caliber: '.357 SIG' },
    'Sig Sauer_P226 DAK-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 DAK-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 Elite-4.4 / .357 SIG': { barrel: '4.4"', caliber: '.357 SIG' },
    'Sig Sauer_P226 Elite-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 Elite-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 Emperor Scorpion-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 Emperor Scorpion-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 Enhanced Elite-4.4 / .357 SIG': { barrel: '4.4"', caliber: '.357 SIG' },
    'Sig Sauer_P226 Enhanced Elite-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 Enhanced Elite-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 HSP': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 Legion-4.4 / .357 SIG': { barrel: '4.4"', caliber: '.357 SIG' },
    'Sig Sauer_P226 Legion-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 Legion-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 MK25': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 Navy': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 SAS': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 Scorpion': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P226 SCT-4.4 / .40 S&W': { barrel: '4.4"', caliber: '.40 S&W' },
    'Sig Sauer_P226 SCT-4.4 / 9 mm': { barrel: '4.4"', caliber: '9mm' },
    'Sig Sauer_P227-4.4 / .45 ACP': { barrel: '4.4"', caliber: '.45 ACP' },
    'Sig Sauer_P227-4.9 / .45 ACP': { barrel: '4.9"', caliber: '.45 ACP' },
    'Sig Sauer_P227 Carry': { barrel: '3.9"', caliber: '.45 ACP' },
    'Sig Sauer_P227 Nitron': { barrel: '4.4"', caliber: '.45 ACP' },
    'Sig Sauer_P227 SAS': { barrel: '3.9"', caliber: '.45 ACP' },
    'Sig Sauer_P228': { barrel: '3.9"', caliber: '9mm' },
    'Sig Sauer_P229-4 / .357 SIG': { barrel: '4"', caliber: '.357 SIG' },
    'Sig Sauer_P229-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Sig Sauer_P229-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Sig Sauer_P230-3.6 / .32 ACP': { barrel: '3.6"', caliber: '.32 ACP' },
    'Sig Sauer_P230-3.6 / .380 ACP': { barrel: '3.6"', caliber: '.380 ACP' },
    'Sig Sauer_P230-3.6 / 9 mm Police': { barrel: '3.6"', caliber: '9mm Police' },
    'Sig Sauer_P232': { barrel: '3.6"', caliber: '.380 ACP' },
    'Sig Sauer_P238': { barrel: '2.7"', caliber: '.380 ACP' },
    'Sig Sauer_P239-3.6 / .357 SIG': { barrel: '3.6"', caliber: '.357 SIG' },
    'Sig Sauer_P239-3.6 / .40 S&W': { barrel: '3.6"', caliber: '.40 S&W' },
    'Sig Sauer_P245': { barrel: '3.9"', caliber: '.45 ACP' },
    'Sig Sauer_P320-4.7 / .40 S&W': { barrel: '4.7"', caliber: '.40 S&W' },
    'Sig Sauer_P320-4.7 / .45 ACP': { barrel: '4.7"', caliber: '.45 ACP' },
    'Sig Sauer_P320-4.7 / 9 mm': { barrel: '4.7"', caliber: '9mm' },
    'Sig Sauer_P320 Compact-3.9 / .357 SIG': { barrel: '3.9"', caliber: '.357 SIG' },
    'Sig Sauer_P320 Compact-3.9 / .40 S&W': { barrel: '3.9"', caliber: '.40 S&W' },
    'Sig Sauer_P320 Compact-3.9 / .45 ACP': { barrel: '3.9"', caliber: '.45 ACP' },
    'Sig Sauer_P320 Compact-3.9 / 9 mm': { barrel: '3.9"', caliber: '9mm' },
    'Sig Sauer_P320 M18': { barrel: '3.9"', caliber: '9mm' },
    'Sig Sauer_P320 Nitron': { barrel: '4.7"', caliber: '9mm' },
    'Sig Sauer_P320 Subcompact-3.6 / .40 S&W': { barrel: '3.6"', caliber: '.40 S&W' },
    'Sig Sauer_P320 Subcompact-3.6 / 9 mm': { barrel: '3.6"', caliber: '9mm' },
    'Sig Sauer_P320 XCarry': { barrel: '3.9"', caliber: '9mm' },
    'Sig Sauer_P320 XCompact': { barrel: '3.6"', caliber: '9mm' },
    'Sig Sauer_P320 XFive': { barrel: '5"', caliber: '9mm' },
    'Sig Sauer_P320 XFive Legion': { barrel: '5"', caliber: '9mm' },
    'Sig Sauer_P320 XFull': { barrel: '4.7"', caliber: '9mm' },
    'Sig Sauer_P320 XTen': { barrel: '5"', caliber: '10mm' },
    'Sig Sauer_P365': { barrel: '3.1"', caliber: '9mm' },
    'Sig Sauer_P365 AXG Legion': { barrel: '3.1"', caliber: '9mm' },
    'Sig Sauer_P365 XL': { barrel: '3.7"', caliber: '9mm' },
    'Sig Sauer_P365 XL Spectre Comp': { barrel: '3.1"', caliber: '9mm' },
    'Sig Sauer_P365 XMacro': { barrel: '3.7"', caliber: '9mm' },
    'Sig Sauer_P365X': { barrel: '3.1"', caliber: '9mm' },
    'Sig Sauer_P938': { barrel: '3"', caliber: '9mm' },
    'Sig Sauer_SP2340-3.9 / .357 SIG': { barrel: '3.9"', caliber: '.357 SIG' },
    'Sig Sauer_SP2340-3.9 / .40 S&W': { barrel: '3.9"', caliber: '.40 S&W' },
    'Smith & Wesson_10 M&P-4 / .38 S&W': { barrel: '4"', caliber: '.38 S&W' },
    'Smith & Wesson_10 M&P-5 / .38 S&W': { barrel: '5"', caliber: '.38 S&W' },
    'Smith & Wesson_10 M&P-6 / .38 S&W': { barrel: '6"', caliber: '.38 S&W' },
    'Smith & Wesson_11-4 / .38 S&W': { barrel: '4"', caliber: '.38 S&W' },
    'Smith & Wesson_11-5 / .38 S&W': { barrel: '5"', caliber: '.38 S&W' },
    'Smith & Wesson_11-6 / .38 S&W': { barrel: '6"', caliber: '.38 S&W' },
    'Smith & Wesson_12-2 / .38 S&W': { barrel: '2"', caliber: '.38 S&W' },
    'Smith & Wesson_12-4 / .38 S&W': { barrel: '4"', caliber: '.38 S&W' },
    'Smith & Wesson_13-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_13-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_14-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Smith & Wesson_14-5 / .38 Special': { barrel: '5"', caliber: '.38 Special' },
    'Smith & Wesson_14-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Smith & Wesson_15-2 / .38 Special': { barrel: '2"', caliber: '.38 Special' },
    'Smith & Wesson_15-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Smith & Wesson_15-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Smith & Wesson_15-8.375 / .38 Special': { barrel: '8.375"', caliber: '.38 Special' },
    'Smith & Wesson_16-4 / .32 S&W Long': { barrel: '4"', caliber: '.32 S&W Long' },
    'Smith & Wesson_16-6 / .32 S&W Long': { barrel: '6"', caliber: '.32 S&W Long' },
    'Smith & Wesson_16-8.375 / .32 Mag': { barrel: '8.375"', caliber: '.32 Mag' },
    'Smith & Wesson_17-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Smith & Wesson_17-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Smith & Wesson_17-8.375 / .22 LR': { barrel: '8.375"', caliber: '.22 LR' },
    'Smith & Wesson_19-2.5 / .357 Mag': { barrel: '2.5"', caliber: '.357 Mag' },
    'Smith & Wesson_19-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_19-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_19-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_22-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Smith & Wesson_22-5.5 / .45 ACP': { barrel: '5.5"', caliber: '.45 ACP' },
    'Smith & Wesson_24': { barrel: '6.5"', caliber: '.44 Special' },
    'Smith & Wesson_25': { barrel: '6.5"', caliber: '.45 Long Colt' },
    'Smith & Wesson_27-3.5 / .357 Mag': { barrel: '3.5"', caliber: '.357 Mag' },
    'Smith & Wesson_27-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_27-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_27-6.5 / .357 Mag': { barrel: '6.5"', caliber: '.357 Mag' },
    'Smith & Wesson_27-8 / .357 Mag': { barrel: '8"', caliber: '.357 Mag' },
    'Smith & Wesson_27-8.375 / .357 Mag': { barrel: '8.375"', caliber: '.357 Mag' },
    'Smith & Wesson_27-8.75 / .357 Mag': { barrel: '8.75"', caliber: '.357 Mag' },
    'Smith & Wesson_27-10.625 / .357 Mag': { barrel: '10.625"', caliber: '.357 Mag' },
    'Smith & Wesson_28-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_28-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_28-8.375 / .357 Mag': { barrel: '8.375"', caliber: '.357 Mag' },
    'Smith & Wesson_29-3 / .44 Mag': { barrel: '3"', caliber: '.44 Mag' },
    'Smith & Wesson_29-4 / .44 Mag': { barrel: '4"', caliber: '.44 Mag' },
    'Smith & Wesson_29-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Smith & Wesson_29-6.5 / .44 Mag': { barrel: '6.5"', caliber: '.44 Mag' },
    'Smith & Wesson_29-8.375 / .44 Mag': { barrel: '8.375"', caliber: '.44 Mag' },
    'Smith & Wesson_29-10.625 / .44 Mag': { barrel: '10.625"', caliber: '.44 Mag' },
    'Smith & Wesson_30': { barrel: '4"', caliber: '.32 S&W Long' },
    'Smith & Wesson_315 Night Guard': { barrel: '2.5"', caliber: '.38 Special' },
    'Smith & Wesson_317-1.875 / .22 LR': { barrel: '1.875"', caliber: '.22 LR' },
    'Smith & Wesson_317-3 / .22 LR': { barrel: '3"', caliber: '.22 LR' },
    'Smith & Wesson_32': { barrel: '2"', caliber: '.38 S&W' },
    'Smith & Wesson_337 AirLite Ti': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_34 Kit Gun': { barrel: '4"', caliber: '.22 LR' },
    'Smith & Wesson_340PD': { barrel: '1.875"', caliber: '.357 Mag' },
    'Smith & Wesson_351C': { barrel: '1.875"', caliber: '.22 Mag' },
    'Smith & Wesson_351PD': { barrel: '1.875"', caliber: '.22 WMR' },
    'Smith & Wesson_36-2 / .38 Special': { barrel: '2"', caliber: '.38 Special' },
    'Smith & Wesson_36-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Smith & Wesson_360': { barrel: '1.875"', caliber: '.357 Mag' },
    'Smith & Wesson_37': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_386': { barrel: '2.5"', caliber: '.357 Mag' },
    'Smith & Wesson_39': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_3904': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_3906': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_3913': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_3914': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_3953': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_3954': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_40': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_4006': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_4013': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_4046': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_41': { barrel: '5.5"', caliber: '.22 LR' },
    'Smith & Wesson_41 (Bull Barrel)': { barrel: '5.5"', caliber: '.22 LR' },
    'Smith & Wesson_42': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_422': { barrel: '4.5"', caliber: '.22 LR' },
    'Smith & Wesson_437': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_438': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_439': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_43C': { barrel: '1.875"', caliber: '.22 LR' },
    'Smith & Wesson_442': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_4506': { barrel: '5"', caliber: '.45 ACP' },
    'Smith & Wesson_457': { barrel: '3.75"', caliber: '.45 ACP' },
    'Smith & Wesson_459': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_46-5 / .22 LR': { barrel: '5"', caliber: '.22 LR' },
    'Smith & Wesson_46-7 / .22 LR': { barrel: '7"', caliber: '.22 LR' },
    'Smith & Wesson_460-3.5 / .460 S&W Mag': { barrel: '3.5"', caliber: '.460 S&W Mag' },
    'Smith & Wesson_460-5 / .460 S&W Mag': { barrel: '5"', caliber: '.460 S&W Mag' },
    'Smith & Wesson_460-7.5 / .460 S&W Mag': { barrel: '7.5"', caliber: '.460 S&W Mag' },
    'Smith & Wesson_460-8.375 / .460 S&W Mag': { barrel: '8.375"', caliber: '.460 S&W Mag' },
    'Smith & Wesson_469': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_48-4 / .22 Mag': { barrel: '4"', caliber: '.22 Mag' },
    'Smith & Wesson_48-6 / .22 Mag': { barrel: '6"', caliber: '.22 Mag' },
    'Smith & Wesson_48-8.375 / .22 Mag': { barrel: '8.375"', caliber: '.22 Mag' },
    'Smith & Wesson_49 Bodyguard': { barrel: '2"', caliber: '.38 Special' },
    'Smith & Wesson_500-3.5 / .500 S&W Mag': { barrel: '3.5"', caliber: '.500 S&W Mag' },
    'Smith & Wesson_500-4 / .500 S&W Mag': { barrel: '4"', caliber: '.500 S&W Mag' },
    'Smith & Wesson_500-7.5 / .500 S&W Mag': { barrel: '7.5"', caliber: '.500 S&W Mag' },
    'Smith & Wesson_500-8.375 / .500 S&W Mag': { barrel: '8.375"', caliber: '.500 S&W Mag' },
    'Smith & Wesson_52': { barrel: '5"', caliber: '.38 Special' },
    'Smith & Wesson_53-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Smith & Wesson_53-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Smith & Wesson_53-8.375 / .22 LR': { barrel: '8.375"', caliber: '.22 LR' },
    'Smith & Wesson_539': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_559': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_57-3 / .41 Mag': { barrel: '3"', caliber: '.41 Mag' },
    'Smith & Wesson_57-4 / .41 Mag': { barrel: '4"', caliber: '.41 Mag' },
    'Smith & Wesson_57-6 / .41 Mag': { barrel: '6"', caliber: '.41 Mag' },
    'Smith & Wesson_57-8.375 / .41 Mag': { barrel: '8.375"', caliber: '.41 Mag' },
    'Smith & Wesson_58': { barrel: '4"', caliber: '.41 Mag' },
    'Smith & Wesson_586-2.5 / .357 Mag': { barrel: '2.5"', caliber: '.357 Mag' },
    'Smith & Wesson_586-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_586-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_586-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_586-8.375 / .357 Mag': { barrel: '8.375"', caliber: '.357 Mag' },
    'Smith & Wesson_59': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_5904': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_5906': { barrel: '3.875"', caliber: '9mm' },
    'Smith & Wesson_5944': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_5946': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_60-1.875 / .38 Special': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_60-2.125 / .357 Mag': { barrel: '2.125"', caliber: '.357 Mag' },
    'Smith & Wesson_60-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_610-4 / 10 mm': { barrel: '4"', caliber: '10mm' },
    'Smith & Wesson_610-6.5 / 10 mm': { barrel: '6.5"', caliber: '10mm' },
    'Smith & Wesson_617-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Smith & Wesson_617-6 / .22 LR': { barrel: '6"', caliber: '.22 LR' },
    'Smith & Wesson_619': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_620': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_622 Field': { barrel: '4.5"', caliber: '.22 LR' },
    'Smith & Wesson_622 Target': { barrel: '4.5"', caliber: '.22 LR' },
    'Smith & Wesson_625-3 / .45 ACP': { barrel: '3"', caliber: '.45 ACP' },
    'Smith & Wesson_625-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Smith & Wesson_625-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Smith & Wesson_627-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_627-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_627-5 / .357 Mag': { barrel: '5"', caliber: '.357 Mag' },
    'Smith & Wesson_629-3 / .44 Mag': { barrel: '3"', caliber: '.44 Mag' },
    'Smith & Wesson_629-4 / .44 Mag': { barrel: '4"', caliber: '.44 Mag' },
    'Smith & Wesson_629-5 / .44 Mag': { barrel: '5"', caliber: '.44 Mag' },
    'Smith & Wesson_629-6 / .44 Mag': { barrel: '6"', caliber: '.44 Mag' },
    'Smith & Wesson_629-6.5 / .44 Mag': { barrel: '6.5"', caliber: '.44 Mag' },
    'Smith & Wesson_63': { barrel: '3"', caliber: '.22 LR' },
    'Smith & Wesson_637': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_638': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_639': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_64-2 / .38 Special': { barrel: '2"', caliber: '.38 Special' },
    'Smith & Wesson_64-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Smith & Wesson_64-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Smith & Wesson_64-6 / .38 Special': { barrel: '6"', caliber: '.38 Special' },
    'Smith & Wesson_640-1.875 / .38 Special': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_640-2 / .357 Mag': { barrel: '2"', caliber: '.357 Mag' },
    'Smith & Wesson_640-2 / .38 Special': { barrel: '2"', caliber: '.38 Special' },
    'Smith & Wesson_640-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Smith & Wesson_642': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_645': { barrel: '5"', caliber: '.45 ACP' },
    'Smith & Wesson_646': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_648': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_649': { barrel: '2.125"', caliber: '.357 Mag' },
    'Smith & Wesson_65': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_659': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_66': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_669': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_67': { barrel: '4"', caliber: '.38 Special' },
    'Smith & Wesson_68': { barrel: '6"', caliber: '.38 Special' },
    'Smith & Wesson_686-2.5 / .357 Mag': { barrel: '2.5"', caliber: '.357 Mag' },
    'Smith & Wesson_686-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_686-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_686-5 / .357 Mag': { barrel: '5"', caliber: '.357 Mag' },
    'Smith & Wesson_686-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_686-8.375 / .357 Mag': { barrel: '8.375"', caliber: '.357 Mag' },
    'Smith & Wesson_686 Plus-2.5 / .357 Mag': { barrel: '2.5"', caliber: '.357 Mag' },
    'Smith & Wesson_686 Plus-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Smith & Wesson_686 Plus-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Smith & Wesson_686 Plus-5 / .357 Mag': { barrel: '5"', caliber: '.357 Mag' },
    'Smith & Wesson_686 Plus-6 / .357 Mag': { barrel: '6"', caliber: '.357 Mag' },
    'Smith & Wesson_686 Plus-7 / .357 Mag': { barrel: '7"', caliber: '.357 Mag' },
    'Smith & Wesson_69-2.75 / .44 Mag': { barrel: '2.75"', caliber: '.44 Mag' },
    'Smith & Wesson_69-4.25 / .44 Mag': { barrel: '4.25"', caliber: '.44 Mag' },
    'Smith & Wesson_6904': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_6906': { barrel: '3.5"', caliber: '9mm' },
    'Smith & Wesson_745': { barrel: '5"', caliber: '.45 ACP' },
    'Smith & Wesson_940': { barrel: '2"', caliber: '9mm' },
    'Smith & Wesson_986-2.5 / 9 mm': { barrel: '2.5"', caliber: '9mm' },
    'Smith & Wesson_986-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Smith & Wesson_Bodyguard 2.0': { barrel: '2.75"', caliber: '.380 ACP' },
    'Smith & Wesson_CSX': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_CSX (E-Series)': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_Equalizer': { barrel: '3.675"', caliber: '9mm' },
    'Smith & Wesson_Governor-2.75 / .410 Bore': { barrel: '2.75"', caliber: '.410 Bore' },
    'Smith & Wesson_Governor-2.75 / .45 ACP': { barrel: '2.75"', caliber: '.45 ACP' },
    'Smith & Wesson_Governor-2.75 / .45 Colt': { barrel: '2.75"', caliber: '.45 Colt' },
    'Smith & Wesson_Ladysmith 1902-1921': { barrel: '1.875"', caliber: '.22 LR' },
    'Smith & Wesson_M&P 10mm M2.0-4 / 10 mm': { barrel: '4"', caliber: '10mm' },
    'Smith & Wesson_M&P 10mm M2.0-4.6 / 10 mm': { barrel: '4.6"', caliber: '10mm' },
    'Smith & Wesson_M&P 340': { barrel: '1.875"', caliber: '.357 Mag' },
    'Smith & Wesson_M&P 342': { barrel: '1.875"', caliber: '.38 Special' },
    'Smith & Wesson_M&P 380 Shield EZ M2.0': { barrel: '3.68"', caliber: '.380 ACP' },
    'Smith & Wesson_M&P 380 Shield EZ M2.0 (Performance Center)': { barrel: '3.8"', caliber: '.380 ACP' },
    'Smith & Wesson_M&P 40 M2.0-3.6 / .40 S&W': { barrel: '3.6"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 M2.0-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 M2.0-4.25 / .40 S&W': { barrel: '4.25"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 M2.0 (Performance Center)': { barrel: '4.25"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 M2.0 (Pro Series C.O.R.E.)': { barrel: '4.25"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 M2.0 (Pro Series)': { barrel: '4.25"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 Shield': { barrel: '3.1"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 Shield M2.0': { barrel: '3.1"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 Shield M2.0 (Performance Center)-3.1 / .40 S&W': { barrel: '3.1"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 40 Shield M2.0 (Performance Center)-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_M&P 45 M2.0-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Smith & Wesson_M&P 45 M2.0-4.6 / .45 ACP': { barrel: '4.6"', caliber: '.45 ACP' },
    'Smith & Wesson_M&P 45 Shield M2.0': { barrel: '3.3"', caliber: '.45 ACP' },
    'Smith & Wesson_M&P 45 Shield M2.0 (Performance Center)-3.3 / .45 ACP': { barrel: '3.3"', caliber: '.45 ACP' },
    'Smith & Wesson_M&P 45 Shield M2.0 (Performance Center)-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Smith & Wesson_M&P 5.7': { barrel: '5"', caliber: '5.7x28mm' },
    'Smith & Wesson_M&P 9 M2.0-3.6 / 9 mm': { barrel: '3.6"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 M2.0-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 M2.0-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 M2.0 (Performance Center)': { barrel: '4.25"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 M2.0 (Pro Series C.O.R.E.)': { barrel: '4.25"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 M2.0 (Pro Series)': { barrel: '4.25"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 M2.0 Carry Comp': { barrel: '4.25"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield EZ (Performance Center)': { barrel: '3.83"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield EZ M2.0': { barrel: '3.68"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield EZ M2.0 (Performance Center)': { barrel: '3.83"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield M2.0': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield M2.0 (Performance Center)-3.1 / 9 mm': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield M2.0 (Performance Center)-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield Plus': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield Plus (Performance Center)-3.1 / 9 mm': { barrel: '3.1"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield Plus (Performance Center)-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_M&P 9 Shield Plus Carry Comp': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_S&W M1917': { barrel: '5.5"', caliber: '.45 ACP' },
    'Smith & Wesson_SD40': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_SD40VE': { barrel: '4"', caliber: '.40 S&W' },
    'Smith & Wesson_SD9': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_SD9VE': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_Shield EZ': { barrel: '3.68"', caliber: '.30 Super' },
    'Smith & Wesson_Shield Plus': { barrel: '3.1"', caliber: '.30 Super' },
    'Smith & Wesson_Sigma SW9VE': { barrel: '4"', caliber: '9mm' },
    'Smith & Wesson_SW22 Victory': { barrel: '5.5"', caliber: '.22 LR' },
    'Springfield Armory_1911 DS Prodigy-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Springfield Armory_1911 DS Prodigy-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_1911 DS Prodigy Comp': { barrel: '4.25"', caliber: '9mm' },
    'Springfield Armory_1911 Emissary-4.25 / .45 ACP': { barrel: '4.25"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Emissary-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Springfield Armory_1911 Emissary-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Emissary-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_1911 Garrison-4.25 / .45 ACP': { barrel: '4.25"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Garrison-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Springfield Armory_1911 Garrison-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Garrison-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_1911 Operator': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Ronin EMP-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Springfield Armory_1911 Ronin EMP-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Springfield Armory_1911 Ronin Operator-4.25 / .45 ACP': { barrel: '4.25"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Ronin Operator-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Springfield Armory_1911 Ronin Operator-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_1911 Ronin Operator-5 / 10 mm': { barrel: '5"', caliber: '10mm' },
    'Springfield Armory_1911 Ronin Operator-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_1911 TRP-4.25 / .45 ACP': { barrel: '4.25"', caliber: '.45 ACP' },
    'Springfield Armory_1911 TRP-4.25 / 9 mm': { barrel: '4.25"', caliber: '9mm' },
    'Springfield Armory_1911 TRP-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_1911 TRP-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_1911-A1-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_1911-A1-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_911-2.7 / .380 ACP': { barrel: '2.7"', caliber: '.380 ACP' },
    'Springfield Armory_911-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Springfield Armory_Echelon 4.5F': { barrel: '4.5"', caliber: '9mm' },
    'Springfield Armory_EMP-3.25 / .40 S&W': { barrel: '3.25"', caliber: '.40 S&W' },
    'Springfield Armory_EMP-3.25 / 9 mm': { barrel: '3.25"', caliber: '9mm' },
    'Springfield Armory_Hellcat': { barrel: '3"', caliber: '9mm' },
    'Springfield Armory_Hellcat OSP': { barrel: '3"', caliber: '9mm' },
    'Springfield Armory_Hellcat Pro': { barrel: '3.7"', caliber: '9mm' },
    'Springfield Armory_XD-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Springfield Armory_XD-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Springfield Armory_XD-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Springfield Armory_XD Mod.2-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Springfield Armory_XD Mod.2-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Springfield Armory_XD Mod.3 OSP': { barrel: '4"', caliber: '9mm' },
    'Springfield Armory_XD Sub-Compact-3 / .40 S&W': { barrel: '3"', caliber: '.40 S&W' },
    'Springfield Armory_XD Sub-Compact-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Springfield Armory_XD Sub-Compact Mod.2-3 / .40 S&W': { barrel: '3"', caliber: '.40 S&W' },
    'Springfield Armory_XD Sub-Compact Mod.2-3 / 9 mm': { barrel: '3"', caliber: '9mm' },
    'Springfield Armory_XD Tactical-5 / .357 SIG': { barrel: '5"', caliber: '.357 SIG' },
    'Springfield Armory_XD Tactical-5 / .40 S&W': { barrel: '5"', caliber: '.40 S&W' },
    'Springfield Armory_XD Tactical-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_XD Tactical-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_XD Tactical Mod.2-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Springfield Armory_XD Tactical Mod.2-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Springfield Armory_XD-E-3.3 / .45 ACP': { barrel: '3.3"', caliber: '.45 ACP' },
    'Springfield Armory_XD-E-3.3 / 9 mm': { barrel: '3.3"', caliber: '9mm' },
    'Springfield Armory_XD-M-3.8 / .40 S&W': { barrel: '3.8"', caliber: '.40 S&W' },
    'Springfield Armory_XD-M-3.8 / .45 ACP': { barrel: '3.8"', caliber: '.45 ACP' },
    'Springfield Armory_XD-M-3.8 / 9 mm': { barrel: '3.8"', caliber: '9mm' },
    'Springfield Armory_XD-M-4.5 / .40 S&W': { barrel: '4.5"', caliber: '.40 S&W' },
    'Springfield Armory_XD-M-4.5 / .45 ACP': { barrel: '4.5"', caliber: '.45 ACP' },
    'Springfield Armory_XD-M-4.5 / 10 mm': { barrel: '4.5"', caliber: '10mm' },
    'Springfield Armory_XD-M-4.5 / 9 mm': { barrel: '4.5"', caliber: '9mm' },
    'Springfield Armory_XD-M Elite-3.8 / .45 ACP': { barrel: '3.8"', caliber: '.45 ACP' },
    'Springfield Armory_XD-M Elite-3.8 / 10 mm': { barrel: '3.8"', caliber: '10mm' },
    'Springfield Armory_XD-M Elite-3.8 / 9 mm': { barrel: '3.8"', caliber: '9mm' },
    'Springfield Armory_XD-M Elite-4.5 / 9 mm': { barrel: '4.5"', caliber: '9mm' },
    'Springfield Armory_XD-M Elite OSP-3.8 / 10 mm': { barrel: '3.8"', caliber: '10mm' },
    'Springfield Armory_XD-M Elite OSP-3.8 / 9 mm': { barrel: '3.8"', caliber: '9mm' },
    'Springfield Armory_XD-M Elite OSP-4.5 / 10 mm': { barrel: '4.5"', caliber: '10mm' },
    'Springfield Armory_XD-M Elite OSP-4.5 / 9 mm': { barrel: '4.5"', caliber: '9mm' },
    'Springfield Armory_XD-S-3.3 / .45 ACP': { barrel: '3.3"', caliber: '.45 ACP' },
    'Springfield Armory_XD-S-3.3 / 9 mm': { barrel: '3.3"', caliber: '9mm' },
    'Springfield Armory_XD-S Mod.2-3.3 / .40 S&W': { barrel: '3.3"', caliber: '.40 S&W' },
    'Springfield Armory_XD-S Mod.2-3.3 / .45 ACP': { barrel: '3.3"', caliber: '.45 ACP' },
    'Springfield Armory_XD-S Mod.2-3.3 / 9 mm': { barrel: '3.3"', caliber: '9mm' },
    'Springfield Armory_XD-S Mod.2 OSP-3.3 / .45 ACP': { barrel: '3.3"', caliber: '.45 ACP' },
    'Springfield Armory_XD-S Mod.2 OSP-3.3 / 9 mm': { barrel: '3.3"', caliber: '9mm' },
    'Staccato_C': { barrel: '3.9"', caliber: '9mm' },
    'Staccato_C2': { barrel: '3.9"', caliber: '9mm' },
    'Staccato_CS': { barrel: '3.5"', caliber: '9mm' },
    'Staccato_CS 2024': { barrel: '3.5"', caliber: '9mm' },
    'Staccato_P': { barrel: '4.4"', caliber: '9mm' },
    'Staccato_XL': { barrel: '5.4"', caliber: '9mm' },
    'Star_BKM': { barrel: '3.9"', caliber: '9mm' },
    'Star_Firestar M40': { barrel: '3.39"', caliber: '.40 S&W' },
    'Star_Firestar M43': { barrel: '3.39"', caliber: '9mm' },
    'Star_Firestar M45': { barrel: '3.8"', caliber: '.45 ACP' },
    'Star_Firestar Plus': { barrel: '3.39"', caliber: '9mm' },
    'Star_Ultrastar': { barrel: '3.5"', caliber: '9mm' },
    'Stoeger_STR-9': { barrel: '4.17"', caliber: '9mm' },
    'Taurus_431-3 / .44 Special': { barrel: '3"', caliber: '.44 Special' },
    'Taurus_431-4 / .44 Special': { barrel: '4"', caliber: '.44 Special' },
    'Taurus_441-3 / .44 Special': { barrel: '3"', caliber: '.44 Special' },
    'Taurus_441-4 / .44 Special': { barrel: '4"', caliber: '.44 Special' },
    'Taurus_445': { barrel: '2"', caliber: '.44 Special' },
    'Taurus_605': { barrel: '2"', caliber: '.357 Mag' },
    'Taurus_65-3 / .357 Mag': { barrel: '3"', caliber: '.357 Mag' },
    'Taurus_65-4 / .357 Mag': { barrel: '4"', caliber: '.357 Mag' },
    'Taurus_66': { barrel: '4"', caliber: '.357 Mag' },
    'Taurus_669': { barrel: '4"', caliber: '.357 Mag' },
    'Taurus_689': { barrel: '4"', caliber: '.357 Mag' },
    'Taurus_73': { barrel: '3"', caliber: '.32 S&W Long' },
    'Taurus_74': { barrel: '3"', caliber: '.32 S&W Long' },
    'Taurus_741-3 / .32 Mag': { barrel: '3"', caliber: '.32 Mag' },
    'Taurus_741-4 / .32 Mag': { barrel: '4"', caliber: '.32 Mag' },
    'Taurus_761': { barrel: '4"', caliber: '.32 Mag' },
    'Taurus_80-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Taurus_80-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Taurus_82-3 / .38 Special': { barrel: '3"', caliber: '.38 Special' },
    'Taurus_82-4 / .38 Special': { barrel: '4"', caliber: '.38 Special' },
    'Taurus_83': { barrel: '4"', caliber: '.38 Special' },
    'Taurus_84': { barrel: '4"', caliber: '.38 Special' },
    'Taurus_85': { barrel: '2"', caliber: '.38 Special' },
    'Taurus_86': { barrel: '4"', caliber: '.38 Special' },
    'Taurus_941-3 / .22 Mag': { barrel: '3"', caliber: '.22 Mag' },
    'Taurus_941-4 / .22 Mag': { barrel: '4"', caliber: '.22 Mag' },
    'Taurus_96': { barrel: '4"', caliber: '.22 LR' },
    'Taurus_G2c-3.25 / .40 S&W': { barrel: '3.25"', caliber: '.40 S&W' },
    'Taurus_G2c-3.25 / 9 mm': { barrel: '3.25"', caliber: '9mm' },
    'Taurus_G2s-3.2 / .40 S&W': { barrel: '3.2"', caliber: '.40 S&W' },
    'Taurus_G2s-3.2 / 9 mm': { barrel: '3.2"', caliber: '9mm' },
    'Taurus_G3': { barrel: '4"', caliber: '9mm' },
    'Taurus_G3c': { barrel: '3.2"', caliber: '9mm' },
    'Taurus_GX4': { barrel: '3.06"', caliber: '9mm' },
    'Taurus_Judge': { barrel: '3"', caliber: '.45 Colt / .410 Bore' },
    'Taurus_Judge Magnum-2.5 / .45 Colt / .410 Bore': { barrel: '2.5"', caliber: '.45 Colt / .410 Bore' },
    'Taurus_Judge Magnum-3 / .45 Colt / .410 Bore': { barrel: '3"', caliber: '.45 Colt / .410 Bore' },
    'Taurus_Judge Public Defender': { barrel: '2"', caliber: '.45 Colt / .410 Bore' },
    'Taurus_Judge Public Defender Poly': { barrel: '2.5"', caliber: '.45 Colt / .410 Bore' },
    'Taurus_M44': { barrel: '4"', caliber: '.44 Mag' },
    'Taurus_Millennium G2-3.2 / .40 S&W': { barrel: '3.2"', caliber: '.40 S&W' },
    'Taurus_Millennium G2-3.2 / 9 mm': { barrel: '3.2"', caliber: '9mm' },
    'Taurus_PT 24/7 Pro-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Taurus_PT 24/7 Pro-4 / .45 ACP': { barrel: '4"', caliber: '.45 ACP' },
    'Taurus_PT 24/7 Pro-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Taurus_PT 738 TCP': { barrel: '2.84"', caliber: '.380 ACP' },
    'Taurus_PT-145 Millennium Pro': { barrel: '3.25"', caliber: '.45 ACP' },
    'Taurus_PT-1911-5 / .45 ACP': { barrel: '5"', caliber: '.45 ACP' },
    'Taurus_PT-1911-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Taurus_PT22': { barrel: '2.75"', caliber: '.22 LR' },
    'Taurus_PT25': { barrel: '2.75"', caliber: '.25 ACP' },
    'Taurus_PT92': { barrel: '5"', caliber: '9mm' },
    'Taurus_PT945': { barrel: '4.25"', caliber: '.45 ACP' },
    'Taurus_PT99': { barrel: '5"', caliber: '9mm' },
    'Taurus_Raging Bull-6.5 / .44 Mag': { barrel: '6.5"', caliber: '.44 Mag' },
    'Taurus_Raging Bull-8.375 / .44 Mag': { barrel: '8.375"', caliber: '.44 Mag' },
    'Taurus_Raging Hornet': { barrel: '10"', caliber: '.22 Hornet' },
    'Taurus_Raging Judge M513': { barrel: '3"', caliber: '.454 Casull' },
    'Taurus_Raging Judge Magnum-3 / .45 Colt': { barrel: '3"', caliber: '.45 Colt' },
    'Taurus_Raging Judge Magnum-3 / .454 Casull': { barrel: '3"', caliber: '.454 Casull' },
    'Taurus_Spectrum': { barrel: '2.8"', caliber: '.380 ACP' },
    'Taurus_Tracker 992': { barrel: '4"', caliber: '.22 LR / .22 WMR' },
    'Walther_CCP': { barrel: '3.54"', caliber: '9mm' },
    'Walther_CCP M2-3.54 / .380 ACP': { barrel: '3.54"', caliber: '.380 ACP' },
    'Walther_CCP M2-3.54 / 9 mm': { barrel: '3.54"', caliber: '9mm' },
    'Walther_P1': { barrel: '4.9"', caliber: '9mm' },
    'Walther_P38': { barrel: '4.9"', caliber: '9mm' },
    'Walther_P5': { barrel: '3.5"', caliber: '9mm' },
    'Walther_P88 Compact': { barrel: '4"', caliber: '9mm' },
    'Walther_P99-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Walther_P99-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Walther_PDP Full Size-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Walther_PDP Full Size-4.5 / 9 mm': { barrel: '4.5"', caliber: '9mm' },
    'Walther_PP-3.86 / .32 ACP': { barrel: '3.86"', caliber: '.32 ACP' },
    'Walther_PP-3.86 / .380 ACP': { barrel: '3.86"', caliber: '.380 ACP' },
    'Walther_PP Super': { barrel: '3.75"', caliber: '9mm Police' },
    'Walther_PPK-3.35 / .32 ACP': { barrel: '3.35"', caliber: '.32 ACP' },
    'Walther_PPK-3.35 / .380 ACP': { barrel: '3.35"', caliber: '.380 ACP' },
    'Walther_PPK/S-3.3 / .32 ACP': { barrel: '3.3"', caliber: '.32 ACP' },
    'Walther_PPK/S-3.3 / .380 ACP': { barrel: '3.3"', caliber: '.380 ACP' },
    'Walther_PPQ-4 / .40 S&W': { barrel: '4"', caliber: '.40 S&W' },
    'Walther_PPQ-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Walther_PPQ 22-4 / .22 LR': { barrel: '4"', caliber: '.22 LR' },
    'Walther_PPQ 22-5 / .22 LR': { barrel: '5"', caliber: '.22 LR' },
    'Walther_PPQ M2-4 / 9 mm': { barrel: '4"', caliber: '9mm' },
    'Walther_PPQ M2-4.1 / .40 S&W': { barrel: '4.1"', caliber: '.40 S&W' },
    'Walther_PPQ M2-5 / 9 mm': { barrel: '5"', caliber: '9mm' },
    'Walther_PPQ M2-5.1 / .40 S&W': { barrel: '5.1"', caliber: '.40 S&W' },
    'Walther_PPS M2-3.18 / .40 S&W': { barrel: '3.18"', caliber: '.40 S&W' },
    'Walther_PPS M2-3.2 / 9 mm': { barrel: '3.2"', caliber: '9mm' },
    'Webley_Mark V': { barrel: '4"', caliber: '.455 Webley' },
    'Webley_Mark VI': { barrel: '6"', caliber: '.455 Webley' },
    'Whitney_Wolverine': { barrel: '4.625"', caliber: '.22 LR' },
    'Wilson Combat_CQB': { barrel: '5"', caliber: '.45 ACP' },
    'Wilson Combat_EDC X9': { barrel: '4"', caliber: '9mm' },
    'Wilson Combat_EDC X9L': { barrel: '5"', caliber: '9mm' }
  };

  // Pre-build normalized index for fuzzy matching
  // Normalization: lowercase, strip all non-alphanumeric chars
  function normalize(s) {
    return s.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  const SPECS_NORMALIZED = {};
  Object.keys(FIREARM_SPECS).forEach(function (k) {
    SPECS_NORMALIZED[normalize(k)] = { original: k, specs: FIREARM_SPECS[k] };
  });

  const TAG_SEP = '_';

  /* ─────────────────────────────────────────────
     CONFIGURAÇÃO
  ───────────────────────────────────────────── */
  const CFG = {
    maxProductsToScan: 50,
    renderDelay: 400,
    cachePrefix: 'ymm_tags_v2_',
    sidebarWidth: '185px',
    defaultOpen: 0,
    debug: true,
  };

  /* ─────────────────────────────────────────────
     PRODUCT SORT ORDER (best-sellers first)
     Handles not listed here appear at the end
     in their original order.
  ───────────────────────────────────────────── */
  const HANDLE_SORT_ORDER = [
    'oracle-ccw-holster-combat-crocodile',
    'oracle-ccw-holster-classic',
    'close-contact-ccw-holster',
    'everyday-cowboy-ccw-holster-5300-series',
    'the-trenchmate-combat-crocodile-edition',
    'the-trenchmate-classic-edition',
    'soft-touch-iwb-holster',
    'snap-off-belt-holster',
    'frontier-holster-1060-series',
    'the-minimalists-ccw-holster',
    'pro-hide™-3-slot-pancake-holster-2800-series',
    'the-range-rider-ambidextrous-leather-holster',
    'crossdraw-holsters',
    'pro-hide™-shoulder-rig-holster-with-magazine-pouch-5100-series',
    'sure-fit-belt-holster-2200-series',
    'surefit-belt-holster-suede-lined-2300-series',
    'pocket-holster-2500-series',
    'pro-hide™-open-top-holster-5200-series',
    'western-loop-derringer-holster',
    'versafit-holster',
    'pro-ride-high-ride-holster-with-thumb-break-5000-series',
    'crossdraw-holster-with-thumb-break',
    'western-style-holsters-1080-series',
    'western-crossdraw-holster-1089-series',
    'duke-style-cowboy-single-loop-holster-1086-series',
    'western-antique-3-loop-holster-1091-series',
    'western-antique-slim-jim-holster-1091-series',
    'deluxe-slim-jim-holsters',
    'embossed-texas-jockstrap-holster',
    'sportsman-bandolier-holster',
    '2-in-1-sportsman-bandolier-holster',
    'scoped-handgun-bandolier-holster',
    'scoped-handgun-holster',
    'western-single-loop-holsters-1082-series',
    'belt-holster-w-clip-case-size-24',
    'cartridge-loop-holster',
    'western-slim-jim-holster',
    'flap-holsters',
    'western-curved-loop-holster',
    'western-crossdraw-holster-1090-series',
    'sheriffs-model-holster-1094-series',
    'universal-ambidextrous-western-holster-1096-series',
    'cowboy-texas-jockstrap-holster',
    'ambidextrous-holster',
    'pro-hide™-interchangeable-holster-body-for-shoulder-rig-5700-series',
    // Add more handles here in your preferred order
  ];
  
  function log(...a) { if (CFG.debug) console.log('[YMM Filter]', ...a); }

  /* ─────────────────────────────────────────────
     SÓ RODA NA PÁGINA DE RESULTADO YMM
  ───────────────────────────────────────────── */
  if (window.location.pathname.indexOf('/pages/product-result') === -1) return;
  const RQ_PARAM = new URLSearchParams(window.location.search).get('rq');
  if (!RQ_PARAM) return;

  log('Iniciando v20...');

  /* ─────────────────────────────────────────────
     PARSE DO PARÂMETRO ?rq=
     Formato: yr_MAKE-WORDS__mk_MODEL-WORDS
     Hífens viram espaços; pontos decimais somem (4.25 → 4-25 → "4 25")
     A normalização de lookup resolve isso.
  ───────────────────────────────────────────── */
  function parseRqParam(rq) {
    const parts = rq.split('__');
    let makeRaw  = '';
    let modelRaw = '';

    parts.forEach(function (p) {
      // yr_ = make (the YMM plugin puts make in yr slot when no year)
      if (p.startsWith('yr_')) makeRaw  = p.slice(3).replace(/-/g, ' ').trim();
      if (p.startsWith('mk_')) modelRaw = p.slice(3).replace(/-/g, ' ').trim();
    });

    return { make: makeRaw, model: modelRaw };
  }

  /* ─────────────────────────────────────────────
     BUSCA SPECS — lookup normalizado
     Tolera perda de pontos decimais, slashes,
     parênteses e outros chars na codificação URL
  ───────────────────────────────────────────── */
  function getFirearmSpecs(make, model) {
    const combined   = make + '_' + model;
    const normKey    = normalize(combined);

    // Exact normalized match
    if (SPECS_NORMALIZED[normKey]) return SPECS_NORMALIZED[normKey].specs;

    // Prefix match: same make, model starts-with lookup model (handles partial)
    const normMake   = normalize(make) + normalize('_');
    const normModel  = normalize(model);
    const keys       = Object.keys(SPECS_NORMALIZED);

    // Try: normalize(make_model) starts with normalize(key) or vice-versa
    let best = null;
    let bestLen = 0;
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (!k.startsWith(normMake)) continue;
      const keyModelPart = k.slice(normMake.length);
      // Check if the key's model normalizes to start with our model or vice-versa
      const shorter = normModel.length < keyModelPart.length ? normModel : keyModelPart;
      const longer  = normModel.length < keyModelPart.length ? keyModelPart : normModel;
      if (longer.startsWith(shorter) && shorter.length > bestLen) {
        bestLen = shorter.length;
        best    = SPECS_NORMALIZED[k].specs;
      }
    }

    return best;
  }

  /* ─────────────────────────────────────────────
     CACHE — sessionStorage
  ───────────────────────────────────────────── */
  function cacheGet(handle) {
    try {
      const raw = sessionStorage.getItem(CFG.cachePrefix + handle);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function cacheSet(handle, data) {
    try { sessionStorage.setItem(CFG.cachePrefix + handle, JSON.stringify(data)); } catch (e) {}
  }

  /* ─────────────────────────────────────────────
     SPINNER FALLBACK
  ───────────────────────────────────────────── */
  function ensureSpinnerExists() {
    if (document.getElementById('ymm-spinner-wrap')) return;
    if (!document.getElementById('ymm-hide-immediate')) {
      const s = document.createElement('style');
      s.id = 'ymm-hide-immediate';
      s.textContent = `.page-ymm-custom .ymm_content, #product_container { visibility: hidden; opacity: 0; }`;
      document.head.appendChild(s);
    }
    const style = document.createElement('style');
    style.textContent = `
      #ymm-spinner-wrap { position: fixed; inset: 0; z-index: 9999;
        display: flex; align-items: center; justify-content: center;
        background: rgba(255,255,255,0.75); backdrop-filter: blur(2px); }
      #ymm-spinner { width: 48px; height: 48px; border: 4px solid #e1e3e4;
        border-top-color: #111; border-radius: 50%;
        animation: ymm-spin 0.75s linear infinite; }
      @keyframes ymm-spin { to { transform: rotate(360deg); } }
    `;
    document.head.appendChild(style);
    const wrap = document.createElement('div');
    wrap.id = 'ymm-spinner-wrap';
    wrap.innerHTML = '<div id="ymm-spinner"></div>';
    (document.body || document.documentElement).appendChild(wrap);
  }

  /* ─────────────────────────────────────────────
     OCULTA BOTÃO "MORE FILTERS" DO PLUGIN YMM
  ───────────────────────────────────────────── */
  function hideYmmMoreFiltersBtn() {
    ['#ymm_filter_btn', '.ymm_filter_btn', '.ymm_filter_btn_cont',
     '[name="ymm_filter_btn"]', '.ymm_facet_filters'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }
  hideYmmMoreFiltersBtn();
  const btnObserver = new MutationObserver(hideYmmMoreFiltersBtn);
  btnObserver.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { btnObserver.disconnect(); }, 15000);

  /* ─────────────────────────────────────────────
     REVELA TUDO
  ───────────────────────────────────────────── */
  function revealAll() {
    const wrap = document.getElementById('ymm-spinner-wrap');
    if (wrap) {
      wrap.style.transition = 'opacity 0.3s ease';
      wrap.style.opacity = '0';
      setTimeout(function () { wrap.remove(); }, 350);
    }
    const hideStyle = document.getElementById('ymm-hide-immediate');
    if (hideStyle) hideStyle.remove();
    const style = document.createElement('style');
    style.textContent = `
      .page-ymm-custom .ymm_content, #product_container {
        visibility: visible !important; opacity: 1 !important; transition: opacity 0.4s ease;
      }
      #ymm-filter-sidebar { animation: ymm-fadein 0.4s ease; }
      @keyframes ymm-fadein { from { opacity:0; } to { opacity:1; } }
    `;
    document.head.appendChild(style);
    log('Conteúdo revelado.');
  }

  /* ─────────────────────────────────────────────
     UPSCALE DE IMAGENS (_240x240 → _800x800)
  ───────────────────────────────────────────── */
  function upscaleProductImages() {
    document.querySelectorAll('#product_container .product-thumb img').forEach(function (img) {
      if (img.dataset.upscaled) return;
      img.dataset.upscaled = '1';

      function upgrade(src) {
        if (!src) return src;
        let u = src.replace(/_\d+x\d+(\.[a-z]+)(\?|$)/i, '_800x800$1$2')
                   .replace(/(\.[a-z]+)\?width=\d+/i, '$1?width=800');
        if (u === src && src.includes('cdn.shopify.com')) {
          u = src.split('?')[0] + '?width=800';
        }
        return u;
      }

      const newSrc = upgrade(img.src);
      if (newSrc !== img.src) img.src = newSrc;
      if (img.srcset) {
        img.srcset = img.srcset.split(',').map(function (e) {
          const p = e.trim().split(' ');
          p[0] = upgrade(p[0]);
          return p.join(' ');
        }).join(', ');
      }
    });
    log('Imagens upscaled.');
  }

  /* ─────────────────────────────────────────────
     PERSONALIZA CABEÇALHO
  ───────────────────────────────────────────── */
  function customizePageHeader() {
    const style = document.createElement('style');
    style.id = 'ymm-header-style';
    style.textContent = `
      #ymm_searchbox h2                 { display: none !important; }
      .page-ymm-custom .section-header  { display: none !important; }
      #total_products                   { display: none !important; }
      #ymm-fit-title {
        font-size: clamp(26px, 4.5vw, 52px); font-weight: 800;
        text-transform: uppercase; letter-spacing: -0.01em; color: #111;
        text-align: center; margin: 0 0 16px; line-height: 1.1; width: 100%;
      }
      #ymm-firearm-label {
        text-align: center; font-size: 15px; color: #444;
        margin: 0 0 28px; line-height: 1.6; width: 100%;
      }
      #ymm-firearm-label strong { color: #111; font-weight: 600; }
      #ymm-firearm-label .ymm-spec-tag {
        display: inline-block; background: #f4f4f0;
        border: 1px solid #e1e3e4; border-radius: 3px;
        padding: 2px 10px; margin: 2px 3px;
        font-size: 13px; font-weight: 500; color: #333;
      }
      
      /*Seção para esconder o nome da arma na exibição dos fitments*/
      #ymm-firearm-label {
        font-size: 0;
        display: none !important;
      }
      #ymm-firearm-label .ymm-spec-tag {
        font-size: 0px; /* ou inherit se quiser manter padrão */
        visibility:hidden;
      }
    `;
    document.head.appendChild(style);

    const handles = new Set();
    document.querySelectorAll('#product_container a[href*="/products/"]').forEach(function (a) {
      const m = a.href.match(/\/products\/([^?#/]+)/);
      if (m) handles.add(m[1]);
    });

    // Título
    const titleEl     = document.createElement('h1');
    titleEl.id        = 'ymm-fit-title';
    titleEl.innerHTML = (handles.size === 1 ? 'This' : 'These') + ' <span id="ymm-fit-count">' + handles.size + '</span> ' + (handles.size === 1 ? 'Holster Fits' : 'Holsters Fit');

    // Firearm label
    const { make, model } = parseRqParam(RQ_PARAM);
    const specs = getFirearmSpecs(make, model);

    function titleCase(s) { return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
    const displayMake  = titleCase(make);
    const displayModel = titleCase(model);

    const labelEl = document.createElement('div');
    labelEl.id    = 'ymm-firearm-label';

    let html = '<strong>Firearm:</strong> ' + displayMake;
    if (displayModel) html += ' ' + displayModel;

    if (specs) {
      html += '&ensp;<span class="ymm-spec-tag">Barrel: ' + specs.barrel + '</span>';
      html += '<span class="ymm-spec-tag">Caliber: ' + specs.caliber + '</span>';
    }

    labelEl.innerHTML = html;

    const mobileBar = document.getElementById('ymm-mobile-bar');
    const anchor = mobileBar || document.getElementById('ymm-filter-layout') || document.getElementById('product_container');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(titleEl, anchor);
      anchor.parentNode.insertBefore(labelEl, anchor);
    }

    log('Header — make:', make, '| model:', model, '| specs:', specs);
  }

  function updateFitCount(n) {
    const el = document.getElementById('ymm-fit-count');
    if (el) el.textContent = n;
    const title = document.getElementById('ymm-fit-title');
    if (title) title.innerHTML = (n === 1 ? 'This' : 'These') + ' <span id="ymm-fit-count">' + n + '</span> ' + (n === 1 ? 'Holster Fits' : 'Holsters Fit');
  }

  /* ─────────────────────────────────────────────
     EXTRAI HANDLES
  ───────────────────────────────────────────── */
  function getProductHandles() {
    const links   = document.querySelectorAll('#product_container a[href*="/products/"]');
    const handles = new Set();
    links.forEach(function (a) {
      const match = a.href.match(/\/products\/([^?#/]+)/);
      if (match && match[1]) handles.add(decodeURIComponent(match[1]));
    });
    return [...handles].slice(0, CFG.maxProductsToScan);
  }

  /* ─────────────────────────────────────────────
     BUSCA DADOS — PARALELA + CACHE
  ───────────────────────────────────────────── */
  const hoverImageMap = {};

  async function fetchProductData(handle) {
    const cached = cacheGet(handle);
    if (cached) {
      if (cached.img2) hoverImageMap[handle] = cached.img2;
      return { handle, tags: cached.tags };
    }
    try {
      const resp = await fetch('/products/' + encodeURIComponent(handle) + '.json', {
        headers: { 'Accept': 'application/json' }
      });
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      const data    = await resp.json();
      const product = data.product || {};
      const tags    = product.tags ? product.tags.split(', ') : [];
      const images  = product.images || [];
      let img2      = null;
      if (images.length >= 2) {
        img2 = images[1].src.split('?')[0] + '?width=800';
        hoverImageMap[handle] = img2;
      }
      cacheSet(handle, { tags, img2 });
      return { handle, tags };
    } catch (err) {
      log('Erro ao buscar dados de', handle, ':', err.message);
      return { handle, tags: [] };
    }
  }

  async function fetchAllProductData(handles) {
    const t0      = performance.now();
    const results = await Promise.all(handles.map(fetchProductData));
    const map     = {};
    results.forEach(function (r) { map[r.handle] = r.tags; });
    log('Dados em', Math.round(performance.now() - t0) + 'ms para', handles.length, 'produtos.');
    return map;
  }

  /* ─────────────────────────────────────────────
     MONTA CATÁLOGO COM CONTAGENS
  ───────────────────────────────────────────── */
  function buildCategoriesFromCatalog(handleTagMap) {
    const tagToHandles = {};
    Object.entries(handleTagMap).forEach(function ([handle, tags]) {
      tags.forEach(function (tag) {
        if (!tagToHandles[tag]) tagToHandles[tag] = new Set();
        tagToHandles[tag].add(handle);
      });
    });
    const result = {};
    FILTER_CATALOG.forEach(function (group) {
      result[group.cat] = {};
      group.vals.forEach(function (val) {
        const fullTag = group.cat + TAG_SEP + val;
        result[group.cat][val] = tagToHandles[fullTag] || new Set();
      });
    });
    return result;
  }

  /* ─────────────────────────────────────────────
     HOVER IMAGE SWAP
  ───────────────────────────────────────────── */
  function attachHoverSwap() {
    document.querySelectorAll('#product_container .ymm-grid-item').forEach(function (card) {
      if (card.dataset.hoverBound) return;
      card.dataset.hoverBound = '1';
      const img  = card.querySelector('.product-thumb img');
      const link = card.querySelector('.product-thumb a');
      if (!img || !link) return;
      const match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      const handle    = decodeURIComponent(match[1]);
      const hoverSrc  = hoverImageMap[handle];
      if (!hoverSrc) return;
      const originalSrc = img.src;
      const preload     = new Image();
      preload.src       = hoverSrc;
      card.addEventListener('mouseenter', function () { img.src = hoverSrc; });
      card.addEventListener('mouseleave', function () { img.src = originalSrc; });
      card.addEventListener('touchstart', function () {
        if (window._ymmActiveHoverCard && window._ymmActiveHoverCard !== card) {
          var prevImg = window._ymmActiveHoverCard.querySelector('.product-thumb img');
          var prevLink = window._ymmActiveHoverCard.querySelector('.product-thumb a');
          if (prevImg && prevLink) {
            var prevMatch = prevLink.href.match(/\/products\/([^?#/]+)/);
            if (prevMatch) {
              var prevHandle = decodeURIComponent(prevMatch[1]);
              var prevOriginal = prevImg.dataset.originalSrc;
              if (prevOriginal) prevImg.src = prevOriginal;
            }
          }
        }
        img.dataset.originalSrc = originalSrc;
        img.src = hoverSrc;
        window._ymmActiveHoverCard = card;
      }, { passive: true });
    });
    log('Hover swap aplicado.');
  }

  /* ─────────────────────────────────────────────
     HUNTER CARD DATA — series label, badge, rating
     The Holster Finder app builds each card from the product title, price
     and photo only. Everything else comes from one small request per
     product: /products/HANDLE?view=hunter-card-data
     (templates/product.hunter-card-data.liquid). It returns:
       series : "Series" metafield (custom.series), e.g. "3600 Series"
       badge  : "Firearm Attachments" metafield, e.g. "New Arrival"
       rating / count : review stars
     The look of the series label and badge is set in
     snippets/hunter-series-style.liquid.
  ───────────────────────────────────────────── */
  const cardDataRequests = {};

  function getCardData(handle) {
    if (cardDataRequests[handle]) return cardDataRequests[handle];
    cardDataRequests[handle] = (async function () {
      const cached = cacheGet('carddata_' + handle);
      if (cached) return cached;
      try {
        const resp = await fetch('/products/' + encodeURIComponent(handle) + '?view=hunter-card-data', {
          headers: { 'Accept': 'text/html' }
        });
        if (!resp.ok) return null;
        const text  = await resp.text();
        const start = text.indexOf('{"hunterCardData"');
        const end   = text.lastIndexOf('}');
        // No marker = the data template is missing on this theme. Treat as "no data".
        if (start === -1 || end < start) return null;
        const raw  = JSON.parse(text.slice(start, end + 1));
        const data = {
          series: String(raw.series || '').trim(),
          badge:  String(raw.badge || '').trim(),
          rating: parseFloat(raw.rating) || 0,
          count:  parseInt(raw.count, 10) || 0
        };
        cacheSet('carddata_' + handle, data);
        return data;
      } catch (e) {
        log('Card data error for', handle, ':', e.message);
        return null;
      }
    })();
    return cardDataRequests[handle];
  }

  async function fetchAndRenderCardData(handles) {
    const dataMap = {};
    await Promise.all(handles.map(async function (handle) {
      const data = await getCardData(handle);
      if (data) dataMap[handle] = data;
    }));

    document.querySelectorAll('#product_container .ymm-grid-item').forEach(function (card) {
      if (card.dataset.seriesBound) return;
      card.dataset.seriesBound = '1';
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      const data = dataMap[decodeURIComponent(match[1])];
      if (!data) return;
      const titleEl = card.querySelector('.ymm-product-details .grid-view-item__title');
      if (!titleEl) return;
      // Order above the title: badge, then series.
      if (data.badge) {
        const badgeEl = document.createElement('div');
        badgeEl.className   = 'hc-finder-badge';
        badgeEl.textContent = data.badge;
        titleEl.parentNode.insertBefore(badgeEl, titleEl);
      }
      if (data.series) {
        const seriesEl = document.createElement('span');
        seriesEl.className   = 'hc-series hc-series--finder';
        seriesEl.textContent = data.series;
        titleEl.parentNode.insertBefore(seriesEl, titleEl);
      }
    });
    log('Card data rendered for', Object.keys(dataMap).length, 'products.');
  }

  /* ─────────────────────────────────────────────
     RATINGS — Storefront API → metafields
  ───────────────────────────────────────────── */
  function buildStarHTML(rating, count) {
    var value     = parseFloat(rating) || 0;
    var countText = count === 1 ? '1 Review' : count + ' Reviews';
    var html      = '';
    for (var i = 1; i <= 5; i++) {
      var diff = value - (i - 1);
      if (diff >= 0.75) {
        html += '<span style="color:#ffab41;font-size:16px;">&#9733;</span>';
      } else if (diff >= 0.25) {
        html += '<span style="display:inline-block;position:relative;width:16px;height:16px;font-size:16px;line-height:1;">'
          + '<span style="color:#ffab41;position:absolute;top:0;left:0;">&#9734;</span>'
          + '<span style="color:#ffab41;position:absolute;top:0;left:0;overflow:hidden;width:50%;">&#9733;</span>'
          + '</span>';
      } else {
        html += '<span style="color:#ffab41;font-size:16px;">&#9734;</span>';
      }
    }
    return '<div style="display:flex;align-items:center;gap:6px;margin-top:6px;">'
      + '<span class="ymm-stars-wrap" style="display:flex;gap:1px;line-height:1;">' + html + '</span>'
      + '<span class="ymm-rating-text" style="font-size:12px;font-family:Rubik,sans-serif;color:#403d3e;font-style:normal;font-weight:400;">' + countText + '</span>'
      + '</div>';
  }

  async function fetchAndRenderRatings(handles) {
    let ratingsMap = {};
    try {
      await Promise.all(handles.map(async function (handle) {
        try {
          var cachedRating = cacheGet('rating_' + handle);
          if (cachedRating) {
            if (cachedRating.rating > 0 && cachedRating.count > 0) ratingsMap[handle] = cachedRating;
            return;
          }
          var cardData = await getCardData(handle);
          if (cardData) {
            if (cardData.rating > 0 && cardData.count > 0) {
              ratingsMap[handle] = { rating: cardData.rating, count: cardData.count };
              cacheSet('rating_' + handle, { rating: cardData.rating, count: cardData.count });
            }
            return;
          }
          // Fallback (card data unavailable): read the rating from the full product page.
          const resp = await fetch('/products/' + encodeURIComponent(handle), {
            headers: { 'Accept': 'text/html' }
          });
          if (!resp.ok) return;
          const html = await resp.text();
          var widgetMatch = html.match(/class=['"]\s*jdgm-rev-widg\s*['"][^>]*data-average-rating=['"]([\d.]+)['"][^>]*data-number-of-reviews=['"]([\d]+)['"]/);
          if (widgetMatch) {
            var rv = parseFloat(widgetMatch[1]);
            var cv = parseInt(widgetMatch[2], 10);
            if (cv > 0 && rv > 0) {
              ratingsMap[handle] = { rating: rv, count: cv };
              cacheSet('rating_' + handle, { rating: rv, count: cv });
            }
          }
        } catch (e) {}
      }));
      log('Ratings:', Object.keys(ratingsMap).length, 'produtos com reviews.');
    } catch (err) { log('Ratings fetch error:', err.message); }

    document.querySelectorAll('#product_container .ymm-grid-item').forEach(function (card) {
      if (card.dataset.ratingBound) return;
      card.dataset.ratingBound = '1';
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const match = link.href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      const handle  = decodeURIComponent(match[1]);
      const rd      = ratingsMap[handle];
      if (!rd || rd.count === 0) return;
      const details = card.querySelector('.ymm-product-details');
      if (!details) return;
      const metaEl  = details.querySelector('.grid-view-item__meta');
      if (metaEl) metaEl.insertAdjacentHTML('afterend', buildStarHTML(rd.rating, rd.count));
      else         details.insertAdjacentHTML('beforeend', buildStarHTML(rd.rating, rd.count));
    });
    log('Ratings renderizados.');
  }

  /* ─────────────────────────────────────────────
     FILTRAGEM CLIENT-SIDE
  ───────────────────────────────────────────── */
  let handleTagMap  = {};
  let activeFilters = {};

  function getHandleFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.href.match(/\/products\/([^?#/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function reorderCards() {
    const grid = document.querySelector('#product_container #products');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.ymm-grid-item'));
    if (!cards.length) return;
    const orderMap = {};
    HANDLE_SORT_ORDER.forEach(function (h, i) { orderMap[h] = i; });
    cards.sort(function (a, b) {
      var hA = getHandleFromCard(a);
      var hB = getHandleFromCard(b);
      var posA = orderMap.hasOwnProperty(hA) ? orderMap[hA] : 9999;
      var posB = orderMap.hasOwnProperty(hB) ? orderMap[hB] : 9999;
      return posA - posB;
    });
    cards.forEach(function (card) { grid.appendChild(card); });
    log('Cards reordered by best-seller sequence.');
  }

  function getVisibleHandles() {
    const cards = document.querySelectorAll(
      '#product_container .grid__item, #product_container [class*="grid__item"]'
    );
    const visible = new Set();
    cards.forEach(function (card) {
      if (card.style.display === 'none') return;
      const h = getHandleFromCard(card);
      if (h) visible.add(h);
    });
    return visible;
  }

  function applyFilters() {
    const cards = document.querySelectorAll(
      '#product_container .grid__item, #product_container [class*="grid__item"]'
    );
    let visible = 0;
    cards.forEach(function (card) {
      const handle      = getHandleFromCard(card);
      if (!handle) { card.style.display = ''; return; }
      const productTags = handleTagMap[handle] || [];
      const passes      = Object.keys(activeFilters).every(function (cat) {
        const val = activeFilters[cat];
        if (!val) return true;
        return productTags.includes(cat + TAG_SEP + val);
      });
      card.style.display = passes ? '' : 'none';
      if (passes) visible++;
    });
    updateFitCount(visible);
    updateClearBtn();
    refreshOptionStates();
    syncUrlFromFilters();
    log('Filtros aplicados:', visible, 'visíveis.');
  }

  function updateClearBtn() {
    const clearBtn = document.getElementById('ymm-filter-clear-btn');
    if (!clearBtn) return;
    const total = Object.values(activeFilters).filter(Boolean).length;
    clearBtn.style.display = total > 0 ? 'inline' : 'none';
    clearBtn.textContent   = 'Clear all (' + total + ')';
  }

  /* ─────────────────────────────────────────────
     FILTERS IN THE URL
     Each active filter becomes a query parameter next to ?rq=, so the
     link can be shared, bookmarked, reloaded or reached with "Back".
       ?rq=yr_glock__mk_19&f_carry-style=inside-waistband-iwb&f_draw-hand=right-hand
     Parameter = "f_" + category slug. Value = option slug.
     Unknown or misspelled values are ignored.
  ───────────────────────────────────────────── */
  const URL_PREFIX = 'f_';

  function slugify(s) {
    return String(s).toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function syncUrlFromFilters() {
    try {
      const params = new URLSearchParams(window.location.search);
      // Drop every filter param we own, then write the current ones
      Array.from(params.keys()).forEach(function (k) {
        if (k.indexOf(URL_PREFIX) === 0) params.delete(k);
      });
      FILTER_CATALOG.forEach(function (group) {
        const val = activeFilters[group.cat];
        if (val) params.set(URL_PREFIX + slugify(group.cat), slugify(val));
      });
      const qs = params.toString();
      const next = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      if (next !== window.location.pathname + window.location.search + window.location.hash) {
        window.history.replaceState(window.history.state, '', next);
      }
    } catch (e) {
      log('URL sync error:', e.message);
    }
  }

  // Reads ?f_... params and returns { 'Carry Style': 'Inside Waistband (IWB)', ... }
  function readFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const found  = {};
    FILTER_CATALOG.forEach(function (group) {
      const raw = params.get(URL_PREFIX + slugify(group.cat));
      if (!raw) return;
      const wanted = slugify(raw);
      const match  = group.vals.find(function (v) { return slugify(v) === wanted; });
      if (match) found[group.cat] = match;
      else log('Unknown value in URL for', group.cat + ':', raw);
    });
    return found;
  }

  function restoreFiltersFromUrl() {
    const found = readFiltersFromUrl();
    const cats  = Object.keys(found);
    if (!cats.length) return;
    activeFilters = Object.assign({}, found);
    cats.forEach(function (cat) {
      const val = found[cat];
      const sel = 'input[type="radio"][data-cat="' + CSS.escape(cat) + '"][data-val="' + CSS.escape(val) + '"]';
      document.querySelectorAll('#ymm-filter-sidebar ' + sel + ', #ymm-filter-drawer ' + sel).forEach(function (r) {
        r.checked = true;
        // Open the group so the shopper sees which filter is on
        const group = r.closest('.ymmsb-group');
        const btn   = group && group.querySelector('.ymmsb-group-btn');
        const body  = btn && document.getElementById(btn.getAttribute('aria-controls'));
        if (btn && body) { btn.setAttribute('aria-expanded', 'true'); body.classList.add('open'); }
      });
    });
    applyFilters();
    updateMobileUI();
    log('Filters restored from URL:', found);
  }

  function refreshOptionStates() {
    const sidebar = document.getElementById('ymm-filter-sidebar');
    if (!sidebar) return;
    const visibleHandles = getVisibleHandles();
    sidebar.querySelectorAll('.ymmsb-option').forEach(function (label) {
      const radio = label.querySelector('input[type="radio"]');
      const badge = label.querySelector('.ymmsb-count');
      if (!radio || !badge) return;
      const cat = radio.dataset.cat;
      const val = radio.dataset.val;
      const tag = cat + TAG_SEP + val;
      let count = 0;
      visibleHandles.forEach(function (handle) {
        if ((handleTagMap[handle] || []).includes(tag)) count++;
      });
      badge.textContent = '(' + count + ')';
      if (radio.checked) {
        label.classList.remove('ymmsb-disabled'); radio.disabled = false;
      } else if (count === 0) {
        label.classList.add('ymmsb-disabled'); radio.disabled = true;
      } else {
        label.classList.remove('ymmsb-disabled'); radio.disabled = false;
      }
    });
  }

  /* ─────────────────────────────────────────────
     ESTILOS
  ───────────────────────────────────────────── */
  /* ─────────────────────────────────────────────
     ESTILOS
  ───────────────────────────────────────────── */
  function injectStyles() {
    const old = document.getElementById('ymm-sidebar-style');
    if (old) old.remove();
    const style = document.createElement('style');
    style.id = 'ymm-sidebar-style';
    style.textContent = `
      /* ── Layout desktop ── */
      #ymm-filter-layout { display: flex; align-items: flex-start; gap: 25px; width: 100%; }
      #ymm-filter-sidebar { width: ${CFG.sidebarWidth}; min-width: ${CFG.sidebarWidth}; flex-shrink: 0; font-family: inherit; }
      #ymm-filter-sidebar-inner { position: sticky; top: 20px; }
      #ymm-filter-layout > #product_container { flex: 1; min-width: 0; }

      /* Reviews */
      .ymm-stars-row { display: flex; align-items: center; gap: 6px; margin-top: 6px; }
      .ymm-stars-wrap { display: inline-flex; gap: 0; }
      .ymm-stars-count { font-size: 12px; font-family: Rubik, sans-serif; color: #403d3e; font-style: normal; font-weight: 400; }
      @font-face {
        font-family: 'YMMStar';
        src: url("data:application/x-font-woff;charset=utf-8;base64,d09GRgABAAAAAAScAA0AAAAABrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAEgAAAABoAAAAcbyQ+3kdERUYAAARgAAAAHgAAACAAMwAGT1MvMgAAAZgAAABGAAAAVi+vS9xjbWFwAAAB8AAAAEAAAAFKwBMjvmdhc3AAAARYAAAACAAAAAj//wADZ2x5ZgAAAkAAAAEJAAABdH33LXtoZWFkAAABMAAAAC0AAAA2BroQKWhoZWEAAAFgAAAAHAAAACQD5QHQaG10eAAAAeAAAAAPAAAAFAYAAABsb2NhAAACMAAAAA4AAAAOAO4AeG1heHAAAAF8AAAAHAAAACAASgAvbmFtZQAAA0wAAADeAAABkorWfVZwb3N0AAAELAAAACkAAABEp3ubLXgBY2BkYADhPPP4OfH8Nl8ZuJkYQODS2fRrCPr/aSYGxq1ALgcDWBoAO60LkwAAAHgBY2BkYGDc+v80gx4TAwgASaAICmABAFB+Arl4AWNgZGBgYGPQYWBiAAIwyQgWc2AAAwAHVQB6eAFjYGRiYJzAwMrAwejDmMbAwOAOpb8ySDK0MDAwMbByMsCBAAMCBKS5pjA4PGB4wMR44P8BBj3GrQymQGFGkBwAjtgK/gAAeAFjYoAAEA1jAwAAZAAHAHgB3crBCcAwDEPRZydkih567CDdf4ZskmLwFBV8xBfCaC4BXkOUmx4sU0h2ngNb9V0vQCxaRKIAevT7fGWuBrEAAAAAAAAAAAA0AHgAugAAeAF9z79Kw1AUx/FzTm7un6QmJtwmQ5Bg1abgEGr/BAqlU6Gju+Cgg1MkQ/sA7Vj7BOnmO/gUvo2Lo14NqIO6/IazfD8HEODtmQCfoMNwNsyp2/GJt3WKQrd1NLiYYWx2PBqOsmJMEOznPOTzfSCrhAtbbLdmeFLJV9eKd63WLrZcIcuaEVdssWCKM6pLCfTVOYbz/0pNSMSZKLIZpvh78sAUH6PlMrreTCabP9r+Z/puPZ2ur/RqpQHgh+MIegCnXeM4MRAPjYN//5tj4ZtTjkFqEdmeMShlEJ7tVAly2TAkx6R68Fl4E/aVvn8JqHFQ4JS1434gXKcuL31dDhzs3YbsEOAd/IU88gAAAHgBfY4xTgMxEEVfkk0AgRCioKFxQYd2ZRtpixxgRU2RfhU5q5VWseQ4JdfgAJyBlmNwAM7ABRhZQ0ORwp7nr+eZAa54YwYg9zm3ynPOeFRe8MCrciXOh/KSS76UV5L/iDmrLiS5AeU519wrL3jmSbkS5115yR2fyivJv9kx0ZMZ2RLZw27q87iNQi8EBo5FSPIMw3HqBboi5lKTGAGDp8FKXWP+t9TU01Lj5His1Ba6uM9dTEMwvrFmbf5GC/q2drW3ruXUhhsCiQOjznFlCzYhHUZp4xp76vsvQh89CQAAeAFjYGJABowM6IANLMrEyMTIzMjCXpyRWJBqZshWXJJYBKOMAFHFBucAAAAAAAAB//8AAngBY2BkYGDgA2IJBhBgAvKZGViBJAuYxwAABJsAOgAAeAFjYGBgZACCk535hiD60tn0azAaAEqpB6wAAA==") format("woff");
        font-weight: normal; font-style: normal;
      }
      .ymm-star { font-family: 'YMMStar'; display: inline; padding: 0 2px 0 0; font-weight: bold; -webkit-font-smoothing: antialiased; }
      .ymm-star:last-child { padding: 0; }
      .ymm-star-full:before { content: "\\e000"; color: #ffab41; }
      .ymm-star-half:before { content: "\\e002"; color: #ffab41; }
      .ymm-star-empty:before { content: "\\e001"; color: #e8e8e1; }

      /* ── Sidebar header ── */
      #ymm-filter-sidebar .ymmsb-header { display: flex; flex-direction: column; align-items: center; margin-bottom: 20px; padding-bottom: 14px; border-bottom: 2px solid #111; }
      #ymm-filter-sidebar .ymmsb-title { font-family: "Averia Serif Libre", serif !important; font-size: 18px; font-weight: 700; color: #111; margin: 0; }
      #ymm-filter-clear-btn { font-size: 14px; color: #F96454; text-decoration: underline; cursor: pointer; border: none; background: none; padding: 12px 0 0; display: none; white-space: nowrap; }
      #ymm-mobile-count { display: none !important; }
      
      #ymm-filter-clear-btn:hover { color: #111; }

      /* ── Accordion ── */
      #ymm-filter-sidebar .ymmsb-group { border-bottom: 1px solid #e1e3e4; }
      #ymm-filter-sidebar .ymmsb-group-btn { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 14px 0; background: none; border: none; cursor: pointer; font-family: sans-serif; font-size: 0.9375rem; font-weight: 700; color: #403d3e; text-align: left; }
      #ymm-filter-sidebar .ymmsb-group-btn span { font-family: Nunito Sans, sans-serif; font-style: normal; font-weight: 700; }
        #ymm-filter-sidebar .ymmsb-group-btn:hover { color: #444; }
      #ymm-filter-sidebar .ymmsb-group-btn .ymmsb-icon { font-size: 20px; font-weight: 300; line-height: 1; color: #666; flex-shrink: 0; margin-left: 8px; transition: transform 0.2s ease; display: inline-block; }
      #ymm-filter-sidebar .ymmsb-group-btn[aria-expanded="true"] .ymmsb-icon { transform: rotate(45deg); }
      #ymm-filter-sidebar .ymmsb-group-body { overflow: hidden; max-height: 0; transition: max-height 0.25s ease; }
      #ymm-filter-sidebar .ymmsb-group-body.open { max-height: 700px; }
      #ymm-filter-sidebar .ymmsb-group-body-inner { padding-bottom: 12px; }

      /* ── Opções (radio) ── */
      #ymm-filter-sidebar .ymmsb-option { display: flex; align-items: center; gap: 10px; padding: 5px 0; cursor: pointer; font-size: 0.9375rem; color: #403D3E; line-height: 1.3; user-select: none; }
      #ymm-filter-sidebar .ymmsb-option:hover:not(.ymmsb-disabled) { color: #111; }
      #ymm-filter-sidebar .ymmsb-option.ymmsb-disabled { opacity: 0.35; cursor: not-allowed; pointer-events: none; }
      #ymm-filter-sidebar .ymmsb-option input[type="radio"] { -webkit-appearance: none; appearance: none; width: 14px; height: 14px; min-width: 14px; border: 1px solid #bbb; border-radius: 2px; cursor: pointer; margin: 0; flex-shrink: 0; background: #fff; transition: background-color 0.15s ease, border-color 0.15s ease; }
      #ymm-filter-sidebar .ymmsb-option-label { flex: 1; }
      #ymm-filter-sidebar .ymmsb-option input[type="radio"]:checked { background-color: #7B5D16; border-color: #7B5D16; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath d='M2.5 7L5.5 10L11.5 4' fill='none' stroke='white' stroke-width='2'/%3E%3C/svg%3E"); background-size: contain; background-position: center; background-repeat: no-repeat; }
      #ymm-filter-sidebar .ymmsb-option input[type="radio"]:checked ~ .ymmsb-option-label,
      #ymm-filter-sidebar .ymmsb-option input[type="radio"]:checked ~ .ymmsb-count { color: #7B5D16 !important; font-weight: 700 !important; }
      #ymm-filter-sidebar .ymmsb-count { font-size: 0.9375rem; color: #403D3E; flex-shrink: 0; }

      /* ── Cards de produto ── */
      #product_container #products.grid { display: grid !important; grid-template-columns: repeat(3, 1fr) !important; gap: 20px !important; margin: 0 !important; padding: 0 !important; }
      #product_container .ymm-grid-item { width: 100% !important; padding: 0 !important; margin: 0 !important; float: none !important; flex: none !important; }
      #product_container .ymm-product-item { display: flex; flex-direction: column; height: 100%; border: 1px solid #e8e8e1; border-radius: 4px; overflow: hidden; background: #fff; transition: box-shadow 0.2s ease; }
      #product_container .ymm-product-item:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
      #product_container .product-thumb { position: relative; width: 100%; aspect-ratio: 1 / 1; background: #f4f4f0; overflow: hidden; min-height: unset !important; margin: 0 !important; display: flex; align-items: center; justify-content: center; }
      #product_container .product-thumb a { display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; }
      #product_container .product-thumb img,
      #product_container .product-thumb .grid-view-item__image { width: 100% !important; height: 100% !important; object-fit: cover; display: block; transition: none; }
      .ymm-grid .ymm-product-item:hover .grid-view-item__image,
      #product_container .ymm-product-item:hover .grid-view-item__image,
      #product_container .ymm-product-item:hover img { opacity: 1 !important; }
      #product_container .ymm-product-details { padding: 14px 16px 18px; display: flex; flex-direction: column; gap: 6px; flex: 1; text-align: left; align-items: flex-start; }
      #product_container .grid-view-item__title { font-size: 14px !important; font-weight: 600 !important; line-height: 1.4 !important; color: #111 !important; margin: 0 !important; padding: 0 !important; }
      #product_container .grid-view-item__title a { color: inherit !important; text-decoration: none !important; display: block; }
      #product_container .grid-view-item__title a:hover { text-decoration: underline !important; }
      #product_container .ymm-product-vendor { font-size: 12px !important; color: #888 !important; font-weight: 400 !important; margin: 2px 0 0 !important; }
      #product_container .ymm-product-vendor a { color: inherit !important; text-decoration: none !important; }
      #product_container .grid-view-item__meta { margin: 4px 0 0 !important; line-height: normal !important; }
      #product_container .grid-view-item__title { margin: 0.625rem 0 0; line-height: 1.3125; letter-spacing: normal; text-transform: none; word-break: break-word; white-space: normal; }
      #product_container .grid-view-item__title a { color: #403d3e; text-decoration: none; font-family: Rubik, sans-serif; font-style: normal; font-weight: 400; font-size: var(--font-size-body, 16px); transition: color 0.1s cubic-bezier(0.4, 0, 0.2, 1); }
      #product_container .grid-view-item__title a:hover { color: #775e25 !important; text-decoration: none !important; }
      /* #product_container .ymm-product-price { font-size: 15px !important; font-weight: 600 !important; color: #c8511a !important; } */
      #product_container .ymm-product-price { font-family: Rubik, sans-serif; color: #7b5d16 !important; font-style: normal; font-weight: 400 !important; font-size: var(--font-size-body, 1rem) !important; }
      #product_container .compare_price { font-size: 13px !important; color: #999 !important; text-decoration: line-through !important; margin-right: 5px !important; }
      #product_container .product__rating { display: flex; align-items: center; gap: 6px; margin-top: 6px; }
      #product_container .rating__star-wrapper { display: flex; gap: 2px; }
      #product_container .rating__star { width: 14px; height: 14px; }
      #product_container .rating__count { font-size: 12px; color: #888; }

      /* ── DESKTOP: sidebar visível normalmente ── */
      @media (min-width: 769px) {
        #ymm-filter-btn-mobile { display: none !important; }
        #ymm-filter-drawer-overlay { display: none !important; }
        #ymm-filter-drawer { display: none !important; }
        #ymm-fit-title { border-top: 1px solid #e1e3e4; padding-top: 16px; border-bottom: 1px solid #e1e3e4; padding-bottom: 16px; margin-bottom: 30px !important; margin-top: 15px !important; }
        .ymm-grid { margin-top: 0px !important; }
        #ymm_searchbox.horizontal { margin-bottom: 0 !important; }
        #ymm_searchbox_cont { height: auto !important; }
        #ymm-firearm-label { display: none !important; }
        #ymm-mobile-bar { display: none !important; }
        #ymm-filter-sidebar .ymmsb-group-btn { font-size: 1rem !important; font-family: sans-serif !important; }
        #product_container .ymm-product-price { font-size: var(--font-size-body, 1rem) !important; }
        #ymm-filter-layout { width: calc(100% + 180px); max-width: 100vw; position: relative; left: 50%; transform: translateX(-50%); box-sizing: border-box; padding-left: 15px; padding-right: 15px; }
        }

      /* ── MOBILE: sidebar oculta, botão + drawer ── */
      @media (max-width: 768px) {
        /* Esconde sidebar lateral */
        #ymm-filter-sidebar { display: none !important; }

        /* Layout de produtos ocupa largura total */
        #ymm-filter-layout { display: block; }
        #product_container #products.grid { grid-template-columns: repeat(2, 1fr) !important; gap: 16px !important; }
        #product_container .ymm-product-details { padding: 14px 11px 18px !important; }
        #product_container .ymm-rating-text { font-size: 11.25px !important; }
        #product_container .ymm-stars-wrap span { font-size: 14px !important; }

        /* Barra mobile com botão de filtros e contagem */
        #ymm-mobile-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          padding: 10px 0;
          border-bottom: none;
        }
        #ymm-fit-title {
          display: block !important;
          border-top: 1px solid #e1e3e4;
          border-bottom: 1px solid #e1e3e4;
          padding-top: 16px;   /* space between top line and title text */
          padding-bottom: 16px;    /* space between title text and bottom line */
          margin-bottom: 12px;    /* space between bottom line and Holster Features button */
        }
        #ymm-mobile-count {
          font-size: 14px;
          color: #555;
        }
        
        #ymm_searchbox_cont { height: auto !important; padding-bottom: 0 !important; margin-bottom: 0 !important; position: relative; z-index: 0; }
        .ymm_app.ymm_res_pg { margin-bottom: 0 !important; display: block !important; }
        #ymm_searchbox { margin-bottom: 0 !important; display: block !important; }
        .ymm-grid { margin-top: 10px !important; }

          /* Botão "Filters" mobile — ORIGINAL STYLES (commented out)
        #ymm-filter-btn-mobile {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #111;
          color: #fff;
          border: none;
          border-radius: 4px;
          padding: 10px 18px;
          font-size: 14px;
          font-weight: 600;
          font-family: inherit;
          cursor: pointer;
          letter-spacing: 0.04em;
        }
        #ymm-filter-btn-mobile .ymm-filter-icon {
          display: flex;
          flex-direction: column;
          gap: 3px;
        }
        #ymm-filter-btn-mobile .ymm-filter-icon span {
          display: block;
          width: 16px;
          height: 2px;
          background: #fff;
          border-radius: 1px;
        }
        #ymm-filter-btn-mobile .ymm-active-badge {
          display: none;
          background: #c8511a;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          border-radius: 10px;
          padding: 1px 7px;
          margin-left: 2px;
        }
        #ymm-filter-btn-mobile.has-filters .ymm-active-badge {
          display: inline;
        }
        END ORIGINAL STYLES */

         /* Botão "Filters" mobile — NEW STYLES */

        #ymm-filter-btn-mobile {
          display: inline-flex;
          align-items: center;
          gap: 0;
          background: transparent;
          color: #7B5D16;
          border: 1px solid #7B5D16;
          border-radius: 4px;
          padding: 12px 18px;
          font-size: 0;
          font-family: "Averia Serif Libre", serif !important;
          font-style: normal;
          font-weight: 600;
          cursor: pointer;
          letter-spacing: 0;
          appearance: none;
          -webkit-appearance: none;
          text-decoration: none;
          outline: none;
          transition: color 100ms cubic-bezier(0.4, 0, 0.2, 1);
        }
        #ymm-filter-btn-mobile:hover { color: #5a4410; border-color: #5a4410; }
        #ymm-filter-btn-mobile .ymm-filter-icon { display: none !important; }
        #ymm-filter-btn-mobile .ymm-filter-icon-svg {
          display: block;
          width: 16px;
          height: 16px;
          fill: currentColor;
          flex-shrink: 0;
          transition: fill 100ms cubic-bezier(0.4, 0, 0.2, 1);
        }
        #ymm-filter-btn-mobile .ymm-filter-btn-text {
          font-size: 17px;
          font-family: "Averia Serif Libre", serif !important;
          font-weight: 600;
          font-style: normal;
          padding-left: 8px;
          vertical-align: middle;
        }
        #ymm-filter-btn-mobile .ymm-filter-btn-text::after {
          content: " \\25BE";
        }
        #ymm-filter-btn-mobile .ymm-active-badge {
          display: none;
          background: #c8511a;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          border-radius: 10px;
          padding: 1px 7px;
          margin-left: 4px;
        }
        #ymm-filter-btn-mobile.has-filters .ymm-active-badge {
          display: inline;
        }

        /* End of Botão "Filters" mobile — NEW STYLES */

        /* Overlay escuro */
        #ymm-filter-drawer-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          z-index: 9998;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }
        #ymm-filter-drawer-overlay.open {
          opacity: 1;
          pointer-events: all;
        }

        /* Drawer deslizando de baixo */
        #ymm-filter-drawer {
          position: fixed;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 9999;
          background: #fff;
          border-radius: 16px 16px 0 0;
          box-shadow: 0 -4px 24px rgba(0,0,0,0.15);
          transform: translateY(100%);
          transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1);
          max-height: 85vh;
          display: flex;
          flex-direction: column;
        }
        #ymm-filter-drawer.open {
          transform: translateY(0);
        }

        /* Handle bar do drawer */
        #ymm-drawer-handle {
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          padding: 12px 0 4px;
        }
        #ymm-drawer-handle::before {
          content: '';
          display: block;
          width: 36px;
          height: 4px;
          background: #ddd;
          border-radius: 2px;
        }

        /* Header do drawer */
        #ymm-drawer-header {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 20px 14px;
          border-bottom: 1px solid #e1e3e4;
        }
        #ymm-drawer-title {
          font-family: "Averia Serif Libre", serif !important;
          font-size: 17px;
          font-weight: 700;
          color: #7b5d16;
          margin: 0;
        }
        #ymm-drawer-close {
          background: none;
          border: none;
          font-size: 24px;
          color: #555;
          cursor: pointer;
          padding: 0 4px;
          line-height: 1;
        }

        /* Conteúdo rolável do drawer */
        #ymm-drawer-body {
          flex: 1;
          overflow-y: auto;
          padding: 0 20px;
          -webkit-overflow-scrolling: touch;
        }

        /* Footer com botões Apply / Clear */
        #ymm-drawer-footer {
          flex-shrink: 0;
          display: flex;
          gap: 10px;
          padding: 14px 20px;
          border-top: 1px solid #e1e3e4;
          background: #fff;
        }
        #ymm-drawer-clear {
          flex: 1;
          padding: 12px;
          border: 2px solid #111;
          background: #fff;
          color: #111;
          font-size: 14px;
          font-weight: 600;
          font-family: inherit;
          border-radius: 4px;
          cursor: pointer;
        }
        #ymm-drawer-apply {
          flex: 2;
          padding: 12px;
          border: none;
          background: #111;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          font-family: inherit;
          border-radius: 4px;
          cursor: pointer;
        }
        #ymm-drawer-apply:hover { background: #333; }
        #ymm-drawer-clear:hover { background: #f4f4f0; }

        /* Reutiliza os estilos da sidebar dentro do drawer */
        #ymm-filter-drawer .ymmsb-group { border-bottom: 1px solid #e1e3e4; }
        #ymm-filter-drawer .ymmsb-group-btn { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 14px 0; background: none; border: none; cursor: pointer; font-family: inherit; font-size: 0.9375rem; font-weight: 700; color: #000; text-align: left; }
        #ymm-filter-drawer .ymmsb-group-btn span { font-family: Nunito Sans, sans-serif; font-style: normal; font-weight: 700; color: #403d3e; }
        #ymm-filter-drawer .ymmsb-group-btn .ymmsb-icon { font-size: 20px; font-weight: 300; line-height: 1; color: #666; flex-shrink: 0; margin-left: 8px; transition: transform 0.2s ease; display: inline-block; }
        #ymm-filter-drawer .ymmsb-group-btn[aria-expanded="true"] .ymmsb-icon { transform: rotate(45deg); }
        #ymm-filter-drawer .ymmsb-group-body { overflow: hidden; max-height: 0; transition: max-height 0.25s ease; }
        #ymm-filter-drawer .ymmsb-group-body.open { max-height: 700px; }
        #ymm-filter-drawer .ymmsb-group-body-inner { padding-bottom: 12px; }
        #ymm-filter-drawer .ymmsb-option { display: flex; align-items: center; gap: 12px; padding: 8px 0; cursor: pointer; font-size: 0.9375rem; color: #403D3E; line-height: 1.3; user-select: none; }
        #ymm-filter-drawer .ymmsb-option.ymmsb-disabled { opacity: 0.35; cursor: not-allowed; pointer-events: none; }
        #ymm-filter-drawer .ymmsb-option input[type="radio"] { -webkit-appearance: none; appearance: none; width: 16px; height: 16px; min-width: 16px; border: 1px solid #bbb; border-radius: 2px; cursor: pointer; margin: 0; flex-shrink: 0; background: #fff; transition: background-color 0.15s ease, border-color 0.15s ease; }
        #ymm-filter-drawer .ymmsb-option-label { flex: 1; }
        #ymm-filter-drawer .ymmsb-option input[type="radio"]:checked { background-color: #7B5D16; border-color: #7B5D16; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath d='M2.5 7L5.5 10L11.5 4' fill='none' stroke='white' stroke-width='2'/%3E%3C/svg%3E"); background-size: contain; background-position: center; background-repeat: no-repeat; }
        #ymm-filter-drawer .ymmsb-option input[type="radio"]:checked ~ .ymmsb-option-label,
        #ymm-filter-drawer .ymmsb-option input[type="radio"]:checked ~ .ymmsb-count { color: #7B5D16 !important; font-weight: 700 !important; }
        #ymm-filter-drawer .ymmsb-count { font-size: 0.9375rem; color: #403D3E; flex-shrink: 0; }

        /* Previne scroll do body quando drawer aberto */
        body.ymm-drawer-open { overflow: hidden; }
      }

      @media (max-width: 480px) {
        #product_container #products.grid { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
      }
    `;
    document.head.appendChild(style);
  }

  /* ─────────────────────────────────────────────
     MOBILE DRAWER
     Cria overlay + drawer com os mesmos filtros
     da sidebar, sincronizado com activeFilters
  ───────────────────────────────────────────── */
  function injectMobileDrawer(groupsHtml) {
    // Remove drawer anterior se existir
    ['ymm-filter-drawer-overlay','ymm-filter-drawer','ymm-mobile-bar']
      .forEach(function (id) {
        const el = document.getElementById(id);
        if (el) el.remove();
      });

    // Overlay
    const overlay = document.createElement('div');
    overlay.id = 'ymm-filter-drawer-overlay';
    document.body.appendChild(overlay);

    // Drawer
    const drawer = document.createElement('div');
    drawer.id = 'ymm-filter-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Filters');
    drawer.innerHTML = `
      <div id="ymm-drawer-handle"></div>
      <div id="ymm-drawer-header">
        <p id="ymm-drawer-title">Holster Features</p>
        <button id="ymm-drawer-close" aria-label="Close filters">&#x2715;</button>
      </div>
      <div id="ymm-drawer-body">${groupsHtml}</div>
      <div id="ymm-drawer-footer">
        <button id="ymm-drawer-clear" type="button">Clear</button>
        <button id="ymm-drawer-apply" type="button">Show Results</button>
      </div>
    `;
    document.body.appendChild(drawer);

    // Barra mobile (acima dos produtos)
    const layout = document.getElementById('ymm-filter-layout');
    const container = document.getElementById('product_container');
    const anchor = layout || container;
    if (anchor && anchor.parentNode) {
      const bar = document.createElement('div');
      bar.id = 'ymm-mobile-bar';
      bar.innerHTML = `
        <span id="ymm-mobile-count"></span>

        <button id="ymm-filter-btn-mobile" type="button" aria-haspopup="dialog" aria-controls="ymm-filter-drawer">
          <span class="ymm-filter-icon">
            <span></span><span></span><span></span>
          </span>
          <svg class="ymm-filter-icon-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><path d="M16,90.3h243.6c7.3,33.4,37.2,58.5,72.8,58.5s65.4-25.1,72.8-58.5H496c8.8,0,16-7.2,16-16s-7.2-16-16-16h-90.8c-7.4-33.4-37.2-58.5-72.8-58.5c-35.5,0-65.4,25.1-72.8,58.5H16c-8.8,0-16,7.2-16,16S7.2,90.3,16,90.3L16,90.3z M289.9,74.3c0-0.1,0-0.1,0-0.2c0.1-23.4,19.1-42.4,42.5-42.4c23.3,0,42.4,19,42.5,42.3l0,0.2c0,23.4-19.1,42.4-42.5,42.4C309,116.8,289.9,97.8,289.9,74.3L289.9,74.3z M496,421.7h-90.8c-7.4-33.4-37.2-58.5-72.8-58.5c-35.5,0-65.4,25.1-72.8,58.5H16c-8.8,0-16,7.2-16,16s7.2,16,16,16h243.6c7.3,33.4,37.2,58.5,72.8,58.5s65.4-25.1,72.8-58.5H496c8.8,0,16-7.2,16-16S504.8,421.7,496,421.7L496,421.7z M332.4,480.2c-23.4,0-42.5-19-42.5-42.4l0-0.1c0-0.1,0-0.1,0-0.2c0.1-23.4,19.1-42.4,42.5-42.4c23.3,0,42.4,19,42.5,42.3l0,0.2C374.9,461.2,355.8,480.2,332.4,480.2L332.4,480.2z M496,240H252.4c-7.3-33.4-37.2-58.5-72.8-58.5s-65.4,25.1-72.8,58.5H16c-8.8,0-16,7.2-16,16c0,8.8,7.2,16,16,16h90.8c7.4,33.4,37.2,58.5,72.8,58.5c35.5,0,65.4-25.1,72.8-58.5H496c8.8,0,16-7.2,16-16C512,247.2,504.8,240,496,240L496,240z M222.1,256c0,0.1,0,0.1,0,0.2c-0.1,23.4-19.1,42.4-42.5,42.4c-23.3,0-42.4-19-42.5-42.3l0-0.2c0-23.4,19.1-42.4,42.5-42.4C203,213.5,222.1,232.5,222.1,256L222.1,256z" fill="currentColor"></path></svg>
          <span class="ymm-filter-btn-text">Holster Features</span>
          <span class="ymm-active-badge" id="ymm-mobile-badge">0</span>
        </button>

      `;
      anchor.parentNode.insertBefore(bar, anchor);
    }

    // ── Funções de abrir/fechar ──
    function openDrawer() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.classList.add('ymm-drawer-open');
      // Sincroniza radios do drawer com activeFilters
      drawer.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.checked = activeFilters[r.dataset.cat] === r.dataset.val;
      });
    }
    function closeDrawer() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.classList.remove('ymm-drawer-open');
    }

    // ── Eventos do drawer ──
    document.getElementById('ymm-filter-btn-mobile').addEventListener('click', openDrawer);
    document.getElementById('ymm-drawer-close').addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    // Accordion dentro do drawer
    drawer.querySelectorAll('.ymmsb-group-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const body     = document.getElementById(this.getAttribute('aria-controls'));
        this.setAttribute('aria-expanded', String(!expanded));
        if (body) body.classList.toggle('open', !expanded);
      });
    });

    // Radio buttons do drawer — toggle igual à sidebar
    drawer.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
        const cat = this.dataset.cat;
        const val = this.dataset.val;
        if (activeFilters[cat] === val) {
          activeFilters[cat] = null;
          this.checked = false;
        } else {
          activeFilters[cat] = val;
        }
        // Sincroniza sidebar desktop
        const sidebarRadio = document.querySelector(
          '#ymm-filter-sidebar input[type="radio"][data-cat="' + CSS.escape(cat) + '"][data-val="' + CSS.escape(val) + '"]'
        );
        if (sidebarRadio) sidebarRadio.checked = this.checked;
        applyFilters();
        updateMobileUI();
      });
    });

    // Botão Apply — apenas fecha
    document.getElementById('ymm-drawer-apply').addEventListener('click', closeDrawer);

    // Botão Clear do drawer
    document.getElementById('ymm-drawer-clear').addEventListener('click', function () {
      activeFilters = {};
      drawer.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
      // Sincroniza sidebar desktop
      document.querySelectorAll('#ymm-filter-sidebar input[type="radio"]').forEach(function (r) { r.checked = false; });
      document.querySelectorAll(
        '#product_container .grid__item, #product_container [class*="grid__item"]'
      ).forEach(function (card) { card.style.display = ''; });
      const handles = new Set();
      document.querySelectorAll('#product_container a[href*="/products/"]').forEach(function (a) {
        const m = a.href.match(/\/products\/([^?#/]+)/);
        if (m) handles.add(m[1]);
      });
      updateFitCount(handles.size);
      updateClearBtn();
      refreshOptionStates();
      updateMobileUI();
      syncUrlFromFilters();
    });

    updateMobileUI();
    log('Mobile drawer injetado.');
  }

  // Atualiza badge e contagem na barra mobile
  function updateMobileUI() {
    const total = Object.values(activeFilters).filter(Boolean).length;
    const btn   = document.getElementById('ymm-filter-btn-mobile');
    const badge = document.getElementById('ymm-mobile-badge');
    const count = document.getElementById('ymm-mobile-count');
    if (btn)   btn.classList.toggle('has-filters', total > 0);
    if (badge) badge.textContent = total;
    if (count) {
      const visible = document.querySelectorAll(
        '#product_container .grid__item:not([style*="none"]), #product_container [class*="grid__item"]:not([style*="none"])'
      ).length;
      count.textContent = visible + (visible === 1 ? ' product' : ' products');
    }

    // Sincroniza estado disabled do drawer com a sidebar
    const sidebar = document.getElementById('ymm-filter-sidebar');
    const drawer  = document.getElementById('ymm-filter-drawer');
    if (!sidebar || !drawer) return;
    drawer.querySelectorAll('.ymmsb-option').forEach(function (label) {
      const radio    = label.querySelector('input[type="radio"]');
      if (!radio) return;
      const cat      = radio.dataset.cat;
      const val      = radio.dataset.val;
      // Espelha disabled state da sidebar
      const sidebarLabel = sidebar.querySelector(
        '.ymmsb-option input[data-cat="' + CSS.escape(cat) + '"][data-val="' + CSS.escape(val) + '"]'
      );
      if (sidebarLabel) {
        const isDisabled = sidebarLabel.disabled && !radio.checked;
        label.classList.toggle('ymmsb-disabled', isDisabled);
        radio.disabled = isDisabled;
        const sidebarBadge = sidebarLabel.parentElement && sidebarLabel.parentElement.querySelector('.ymmsb-count');
        const drawerBadge  = label.querySelector('.ymmsb-count');
        if (sidebarBadge && drawerBadge) drawerBadge.textContent = sidebarBadge.textContent;
      }
    });
  }

  /* ─────────────────────────────────────────────
     INJETA SIDEBAR LATERAL
  ───────────────────────────────────────────── */
  function injectFilterSidebar(categories) {
    const oldLayout = document.getElementById('ymm-filter-layout');
    if (oldLayout) {
      const container = document.getElementById('product_container');
      if (container) oldLayout.parentNode.insertBefore(container, oldLayout);
      oldLayout.remove();
    }
    injectStyles();

    let groupsHtml = '';
    FILTER_CATALOG.forEach(function (group, catIdx) {
      const cat       = group.cat;
      const vals      = categories[cat] || {};
      const isOpen    = CFG.defaultOpen === 'all' || CFG.defaultOpen === catIdx;
      const catId     = 'ymmsb-cat-' + cat.replace(/[^a-z0-9]/gi, '-').toLowerCase();
      const radioName = 'ymm-radio-' + cat.replace(/[^a-z0-9]/gi, '-').toLowerCase();

      let optsHtml = '';
      function escAttr(s) { return s.replace(/"/g, '&quot;'); }
      group.vals.forEach(function (val) {
        const count    = (vals[val] || new Set()).size;
        const disabled = count === 0 ? 'ymmsb-disabled' : '';
        const disAttr  = count === 0 ? 'disabled' : '';
        const radioId  = 'ymmsb-r-' + (cat + '-' + val).replace(/[^a-z0-9]/gi, '-').toLowerCase();
        optsHtml += `
          <label class="ymmsb-option ${disabled}">
            <input type="radio" id="${radioId}" name="${radioName}"
              data-cat="${escAttr(cat)}" data-val="${escAttr(val)}" ${disAttr}>
            <span class="ymmsb-option-label">${val}</span>
            <span class="ymmsb-count" data-count-cat="${escAttr(cat)}" data-count-val="${escAttr(val)}">(${count})</span>
          </label>`;
      });

      groupsHtml += `
        <div class="ymmsb-group">
          <button class="ymmsb-group-btn"
            aria-expanded="${isOpen}" aria-controls="${catId}" data-cat="${cat}">
            <span>${cat}</span><span class="ymmsb-icon">+</span>
          </button>
          <div class="ymmsb-group-body${isOpen ? ' open' : ''}" id="${catId}" role="region">
            <div class="ymmsb-group-body-inner">${optsHtml}</div>
          </div>
        </div>`;
    });

    const sidebar = document.createElement('div');
    sidebar.id = 'ymm-filter-sidebar';
    sidebar.innerHTML = `
      <div id="ymm-filter-sidebar-inner">
        <div class="ymmsb-header">
          <p class="ymmsb-title">Holster Features</p>
          <button id="ymm-filter-clear-btn" type="button">Clear all</button>
        </div>
        ${groupsHtml}
      </div>
    `;

    const container = document.getElementById('product_container');
    if (!container) { log('ATENÇÃO: #product_container não encontrado.'); return; }
    const layout = document.createElement('div');
    layout.id = 'ymm-filter-layout';
    container.parentNode.insertBefore(layout, container);
    layout.appendChild(sidebar);
    layout.appendChild(container);

    // Accordion da sidebar
    sidebar.querySelectorAll('.ymmsb-group-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const body     = document.getElementById(this.getAttribute('aria-controls'));
        this.setAttribute('aria-expanded', String(!expanded));
        if (body) body.classList.toggle('open', !expanded);
      });
    });

    // Radio buttons da sidebar
    sidebar.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('click', function () {
        const cat = this.dataset.cat;
        const val = this.dataset.val;
        if (activeFilters[cat] === val) {
          activeFilters[cat] = null;
          this.checked = false;
        } else {
          activeFilters[cat] = val;
        }
        // Sincroniza drawer mobile
        const drawerRadio = document.querySelector(
          '#ymm-filter-drawer input[type="radio"][data-cat="' + CSS.escape(cat) + '"][data-val="' + CSS.escape(val) + '"]'
        );
        if (drawerRadio) drawerRadio.checked = this.checked || false;
        applyFilters();
        updateMobileUI();
      });
    });

    // Clear all da sidebar
    document.getElementById('ymm-filter-clear-btn').addEventListener('click', function () {
      activeFilters = {};
      sidebar.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
      document.querySelectorAll('#ymm-filter-drawer input[type="radio"]').forEach(function (r) { r.checked = false; });
      document.querySelectorAll(
        '#product_container .grid__item, #product_container [class*="grid__item"]'
      ).forEach(function (card) { card.style.display = ''; });
      const handles = new Set();
      document.querySelectorAll('#product_container a[href*="/products/"]').forEach(function (a) {
        const m = a.href.match(/\/products\/([^?#/]+)/);
        if (m) handles.add(m[1]);
      });
      updateFitCount(handles.size);
      updateClearBtn();
      refreshOptionStates();
      updateMobileUI();
      syncUrlFromFilters();
    });

    // Injeta o drawer mobile com os mesmos grupos (IDs distintos com sufixo -m)
    const drawerGroupsHtml = groupsHtml
      .replace(/id="ymmsb-cat-/g, 'id="ymmsb-cat-m-')
      .replace(/aria-controls="ymmsb-cat-/g, 'aria-controls="ymmsb-cat-m-')
      .replace(/id="ymmsb-r-/g, 'id="ymmsb-r-m-')
      .replace(/name="ymm-radio-/g, 'name="ymm-radio-m-');

    injectMobileDrawer(drawerGroupsHtml);

    log('Sidebar injetada com drawer mobile.');
  }

  async function init() {
    ensureSpinnerExists();

    let attempts = 0;
    await new Promise(function (resolve) {
      const check = setInterval(function () {
        attempts++;
        const links = document.querySelectorAll('#product_container a[href*="/products/"]');
        if (links.length > 0) {
          clearInterval(check);
          log('Produtos detectados após', attempts * 200, 'ms.');
          setTimeout(resolve, CFG.renderDelay);
          return;
        }
        if (attempts > 150) { clearInterval(check); resolve(); }
      }, 200);
    });

    const handles = getProductHandles();
    if (!handles.length) { revealAll(); return; }

    log('Buscando dados de', handles.length, 'produtos...');
    var cardDataPromise = fetchAndRenderCardData(handles).catch(function (e) {
      log('Card data error:', e.message);
    });
    var ratingsPromise = fetchAndRenderRatings(handles).catch(function (e) {
      log('Erro ao buscar ratings:', e.message);
    });
    handleTagMap = await fetchAllProductData(handles);

    const categories = buildCategoriesFromCatalog(handleTagMap);
    injectFilterSidebar(categories);
    customizePageHeader();
    upscaleProductImages();
    reorderCards();
    restoreFiltersFromUrl();
    await Promise.race([
      cardDataPromise,
      new Promise(function (resolve) { setTimeout(resolve, 2500); })
    ]);
    revealAll();
    attachHoverSwap();
    await ratingsPromise;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();